const GL_ISO_CODES = new Map()
// The component optionally offers (-1000, 'Other')
GL_ISO_CODES.set(10010, 'Air Conditioning Equipment--Dealers or Distributors Only')
GL_ISO_CODES.set(10015, 'Amusement Centers')
GL_ISO_CODES.set(10020, 'Amusement Parks')
GL_ISO_CODES.set(10026, 'Antique Stores')
GL_ISO_CODES.set(10036, 'Anhydrous Ammonia Dealers and Distributors')
GL_ISO_CODES.set(10040, 'Appliance Distributors--Household Type')
GL_ISO_CODES.set(10042, 'Appliance Stores--Household Type')
GL_ISO_CODES.set(10052, 'Archery Ranges--Indoor')
GL_ISO_CODES.set(10054, 'Archery Ranges--Other Than Indoor')
GL_ISO_CODES.set(10060, 'Army and Navy Stores')
GL_ISO_CODES.set(10065, 'Art Galleries--Other Than Not-For-Profit')
GL_ISO_CODES.set(10066, 'Art Galleries--Not-For-Profit Only')
GL_ISO_CODES.set(10070, 'Automobile Parts and Supplies Distributors')
GL_ISO_CODES.set(10071, 'Automobile Parts and Supplies Stores')
GL_ISO_CODES.set(10072, 'Automobile Quick Lubrication Services')
GL_ISO_CODES.set(10073, 'Automobile Repair or Service Shops')
GL_ISO_CODES.set(10075, 'Automobile Repair Shops--Self-Service')
GL_ISO_CODES.set(10100, 'Bakeries')
GL_ISO_CODES.set(10101, 'Boat Dealers')
GL_ISO_CODES.set(10105, 'Boat Storage and Moorage')
GL_ISO_CODES.set(10107, 'Boat Yards or Marinas--Public')
GL_ISO_CODES.set(10110, 'Boats--Canoes or Rowboats--for Rent--Not Equipped with Motors')
GL_ISO_CODES.set(10111, 'Barber or Beauty Shop Supplies Distributors')
GL_ISO_CODES.set(10113, 'Barber Shops')
GL_ISO_CODES.set(10115, 'Beauty Parlors and Hair Styling Salons')
GL_ISO_CODES.set(10117, 'Boats--Motor or Sail--Rented to Others')
GL_ISO_CODES.set(10119, 'Boats--Rented to Others NOC')
GL_ISO_CODES.set(10120, 'Bathhouses or Bathing Pavilions')
GL_ISO_CODES.set(10130, 'Bazaars--Operated by the Insured--Other Than Not-For-Profit')
GL_ISO_CODES.set(10132, 'Bazaars--Operated by the Insured--Not-For-Profit Only')
GL_ISO_CODES.set(10133, 'Beach Chairs and Umbrellas--Rented to Others')
GL_ISO_CODES.set(10135, 'Beaches--Bathing--Commercially Operated')
GL_ISO_CODES.set(10140, 'Beverage Distributors--Alcoholic Other Than Beer')
GL_ISO_CODES.set(10141, 'Beverage Distributors--Nonalcoholic and Beer')
GL_ISO_CODES.set(10145, 'Beverage Stores--Liquor and Wine')
GL_ISO_CODES.set(10146, 'Beverage Stores--Soft Drinks and Beer')
GL_ISO_CODES.set(10150, 'Bicycle Stores--Sales and Servicing')
GL_ISO_CODES.set(10151, 'Bicycles--Rented to Others')
GL_ISO_CODES.set(10160, 'Billiard or Pool Halls')
GL_ISO_CODES.set(10204, 'Books and Magazines Stores--Other Than Not-For-Profit')
GL_ISO_CODES.set(10205, 'Books and Magazines Stores--Not-For-Profit Only')
GL_ISO_CODES.set(10220, 'Bowling Lanes')
GL_ISO_CODES.set(10255, 'Building Material Dealers--Other Than Secondhand Material')
GL_ISO_CODES.set(10256, 'Building Material Dealers--Secondhand Material')
GL_ISO_CODES.set(10257, 'Building Material Distributors')
GL_ISO_CODES.set(10309, 'Camera and Photographic Equipment Stores')
GL_ISO_CODES.set(10315, 'Camper or Travel Trailer Sales Agencies')
GL_ISO_CODES.set(10331, 'Campgrounds--Other Than Not-For-Profit')
GL_ISO_CODES.set(10332, 'Campgrounds--Not-For-Profit Only')
GL_ISO_CODES.set(10352, 'Candy or Confectionery Stores')
GL_ISO_CODES.set(10367, 'Car Washes--Other Than Self-Service')
GL_ISO_CODES.set(10368, 'Car Washes--Self-Service')
GL_ISO_CODES.set(10375, 'Carnival or Circus Companies')
GL_ISO_CODES.set(10378, "Carnivals--Outside (Sponsor's Risk Only) Other Than Not-For-Profit")
GL_ISO_CODES.set(10379, "Carnivals--Outside (Sponsor's Risk Only) Not-For-Profit Only")
GL_ISO_CODES.set(10380, "Carnivals or Circuses--in Tents (Sponsor's Risk Only) Other Than Not-For-Profit")
GL_ISO_CODES.set(10381, "Carnivals or Circuses--in Tents (Sponsor's Risk Only) Not-For-Profit Only")
GL_ISO_CODES.set(11007, 'Carpet, Rug or Upholstery Cleaning--Shop Only')
GL_ISO_CODES.set(11020, 'Catalog or Premium Coupon Redemption Stores')
GL_ISO_CODES.set(11039, 'Caterers')
GL_ISO_CODES.set(11052, 'Chairs--Rented to Others')
GL_ISO_CODES.set(11101, 'Chemical Distributors')
GL_ISO_CODES.set(11120, "Children's Playcenter--Indoor")
GL_ISO_CODES.set(11126, 'Clothing or Wearing Apparel Distributors')
GL_ISO_CODES.set(11127, 'Clothing or Wearing Apparel Stores--Other Than Not-For-Profit')
GL_ISO_CODES.set(11128, 'Clothing or Wearing Apparel Stores--Not-For-Profit Only')
GL_ISO_CODES.set(11138, 'Clubs--Country or Golf')
GL_ISO_CODES.set(11155, 'Collectibles and Memorabilia Stores')
GL_ISO_CODES.set(11160, 'Computer Stores')
GL_ISO_CODES.set(11167, 'Concessionaires--Checkroom, Shoeshine or Toilet Concessions in Hotels, Restaurants, Railroad Stations, etc.')
GL_ISO_CODES.set(11168, 'Concessionaires')
GL_ISO_CODES.set(
  11201,
  'Contractors Equipment--Cranes, Derricks, Power Shovels and Equipment Incidental Thereto--Rented to Others with Operators'
)
GL_ISO_CODES.set(
  11202,
  'Contractors Equipment--Cranes, Derricks, Power Shovels and Equipment Incidental Thereto--Rented to Others without Operators'
)
GL_ISO_CODES.set(11203, 'Contractors Equipment Dealers--Ladders, Excluding Hoists, Scaffolds or Towers')
GL_ISO_CODES.set(11204, 'Contractors Equipment Dealers--Ladders, Hoists, Scaffolds or Towers')
GL_ISO_CODES.set(
  11205,
  'Contractors Equipment--Earth Moving Equipment Other Than Cranes, Derricks and Power Shovels--Rented to Others with Operators'
)
GL_ISO_CODES.set(
  11206,
  'Contractors Equipment--Earth Moving Equipment Other Than Cranes, Derricks and Power Shovels--Rented to Others without Operators'
)
GL_ISO_CODES.set(11207, 'Contractors Equipment--Excluding Automobiles--Rented to Others with Operators')
GL_ISO_CODES.set(11208, 'Contractors Equipment--Excluding Automobiles--Rented to Others without Operators')
GL_ISO_CODES.set(
  11209,
  'Contractors Equipment--Hod or Material Platform Hoists and Equipment Incidental Thereto--Rented to Others with Operators'
)
GL_ISO_CODES.set(
  11210,
  'Contractors Equipment--Hod or Material Platform Hoists and Equipment Incidental Thereto--Rented to Others without Operators'
)
GL_ISO_CODES.set(
  11211,
  'Contractors Equipment--Ladders, Scaffolds, Scaffolding, Sidewalk Bridges, Towers and Equipment Incidental Thereto--Rented to Others'
)
GL_ISO_CODES.set(
  11212,
  'Contractors Equipment--Scaffolds, Sidewalk Bridges, Hod or Material Hoists, Towers--Rented to Others--Installation, Repair or Removal Operations Only'
)
GL_ISO_CODES.set(
  11213,
  'Contractors Equipment--Steam Boilers, Compressors, Air Pressure Tanks, Pneumatic Tools and Equipment Incidental Thereto--Rented to Others with Operators'
)
GL_ISO_CODES.set(
  11214,
  'Contractors Equipment--Steam Boilers, Compressors, Air Pressure Tanks, Pneumatic Tools and Equipment Incidental Thereto--Rented to Others without Operators'
)
GL_ISO_CODES.set(11222, 'Copying and Duplicating Services--Retail')
GL_ISO_CODES.set(11234, 'Cosmetic, Hair or Skin Preparation Stores')
GL_ISO_CODES.set(11248, 'Cotton or Wool Merchants')
GL_ISO_CODES.set(11258, 'Dairy Products or Butter and Egg Stores--Other Than Not-For-Profit')
GL_ISO_CODES.set(11259, 'Dairy Products or Butter and Egg Stores--Not-For-Profit Only')
GL_ISO_CODES.set(11273, 'Dance Halls, Ballrooms or Discotheques--Other Than Not-For-Profit')
GL_ISO_CODES.set(11274, 'Dance Halls, Ballrooms or Discotheques--Not-For-Profit Only')
GL_ISO_CODES.set(11288, 'Delicatessens')
GL_ISO_CODES.set(12014, 'Dental Laboratories')
GL_ISO_CODES.set(12356, 'Department or Discount Stores')
GL_ISO_CODES.set(12361, 'Distributors--Food or Drink')
GL_ISO_CODES.set(12362, 'Distributors--No Food or Drink')
GL_ISO_CODES.set(12373, 'Drug Distributors')
GL_ISO_CODES.set(12374, 'Drugstores--No Table or Counter Service for Beverage or Food')
GL_ISO_CODES.set(12375, 'Drugstores')
GL_ISO_CODES.set(12391, 'Electrical Equipment Distributors')
GL_ISO_CODES.set(12393, 'Electronics Store')
GL_ISO_CODES.set(12467, 'Equipment, Fixtures or Supplies--for Bars, Hotels, Offices, Restaurants or Stores--Distributors')
GL_ISO_CODES.set(12509, 'Fabric Distributors')
GL_ISO_CODES.set(12510, 'Fabric Stores')
GL_ISO_CODES.set(12583, 'Feed, Grain or Hay Dealers')
GL_ISO_CODES.set(12651, 'Fence Dealers')
GL_ISO_CODES.set(12683, 'Fertilizer Dealers and Distributors')
GL_ISO_CODES.set(12707, 'Fire Protection Equipment Dealers and Distributors')
GL_ISO_CODES.set(12797, 'Floor Covering Distributors')
GL_ISO_CODES.set(12805, 'Floor Covering Stores')
GL_ISO_CODES.set(12841, 'Florists')
GL_ISO_CODES.set(12927, 'Formal Wear or Costumes--Rented to Others')
GL_ISO_CODES.set(13049, 'Frozen Food--Distributors')
GL_ISO_CODES.set(13111, 'Fruit or Vegetable Dealers')
GL_ISO_CODES.set(13112, 'Fruit or Vegetable Distributors')
GL_ISO_CODES.set(13201, 'Fuel Dealers or Distributors--Coal or Wood')
GL_ISO_CODES.set(13204, 'Fuel Oil or Kerosene Dealers')
GL_ISO_CODES.set(13205, 'Fuel Oil or Kerosene Distributors')
GL_ISO_CODES.set(13314, 'Fur--Garments and Pelts--Distributors')
GL_ISO_CODES.set(13351, 'Furniture Stores--Other Than Not-For-Profit')
GL_ISO_CODES.set(13352, 'Furniture Stores--Not-For-Profit Only')
GL_ISO_CODES.set(13410, 'Gas Dealers--LPG')
GL_ISO_CODES.set(13411, 'Gas Dealers or Distributors')
GL_ISO_CODES.set(13412, 'Gas Distributors--LPG')
GL_ISO_CODES.set(13453, 'Gasoline Stations--Full Service')
GL_ISO_CODES.set(13454, 'Gasoline Stations--Self-Service')
GL_ISO_CODES.set(13455, 'Gasoline Stations--Self and Full Service Combined')
GL_ISO_CODES.set(13506, 'Gift Shops--Other Than Not-For-Profit')
GL_ISO_CODES.set(13507, 'Gift Shops--Not-For-Profit Only')
GL_ISO_CODES.set(13590, 'Glass Dealers and Glaziers')
GL_ISO_CODES.set(13621, 'Grain Milling')
GL_ISO_CODES.set(13670, 'Grocery Distributors')
GL_ISO_CODES.set(13673, 'Grocery Stores')
GL_ISO_CODES.set(13715, 'Hardware and Tool Distributors')
GL_ISO_CODES.set(13716, 'Hardware Stores')
GL_ISO_CODES.set(13720, 'Health or Natural Food Stores')
GL_ISO_CODES.set(13759, 'Hearing Aid Stores')
GL_ISO_CODES.set(13930, 'Heating or Combined Heating and Air Conditioning Equipment--Dealers or Distributors Only')
GL_ISO_CODES.set(14068, 'Hide Dealers and Distributors--Raw')
GL_ISO_CODES.set(14101, "Hobby, Craft or Artists' Supply Stores")
GL_ISO_CODES.set(14279, 'Home Improvement Stores')
GL_ISO_CODES.set(14401, 'Ice Cream Stores')
GL_ISO_CODES.set(14405, 'Ice Dealers and Distributors')
GL_ISO_CODES.set(14527, 'Janitorial Supplies--Dealers or Distributors')
GL_ISO_CODES.set(14655, 'Jewelry Stores or Distributors')
GL_ISO_CODES.set(14731, 'Laundries and Dry Cleaners--Self-Service')
GL_ISO_CODES.set(14732, 'Laundry and Dry Cleaning or Dyeing Receiving Stations')
GL_ISO_CODES.set(14733, 'Laundry and Dry Cleaning Stores')
GL_ISO_CODES.set(14734, 'Laundry Rental Service')
GL_ISO_CODES.set(14855, 'Livestock Dealers or Commission Merchants')
GL_ISO_CODES.set(14913, 'Locksmiths')
GL_ISO_CODES.set(15060, 'Machinery or Equipment Dealers--Construction or Industrial--Mobile Type')
GL_ISO_CODES.set(15061, 'Machinery or Equipment Dealers--Farm Type')
GL_ISO_CODES.set(15062, 'Machinery or Equipment Dealers')
GL_ISO_CODES.set(15063, 'Machinery or Equipment Dealers--Yard or Garden Type')
GL_ISO_CODES.set(15070, 'Mail Box or Packaging Stores')
GL_ISO_CODES.set(15119, "Markets--Not Open Air (Lessor's Risk Only) Other Than Not-For-Profit")
GL_ISO_CODES.set(15120, "Markets--Not Open Air (Lessor's Risk Only) Not-For-Profit Only")
GL_ISO_CODES.set(15123, "Markets--Open Air (Lessor's Risk Only) Other Than Not-For-Profit")
GL_ISO_CODES.set(15124, "Markets--Open Air (Lessor's Risk Only) Not-For-Profit Only")
GL_ISO_CODES.set(15188, 'Oil or Gas Well Supplies or Equipment Dealers--Secondhand')
GL_ISO_CODES.set(15223, 'Meat, Fish, Poultry or Seafood--Distributors')
GL_ISO_CODES.set(15224, 'Meat, Fish, Poultry or Seafood Stores')
GL_ISO_CODES.set(15300, 'Medical, Hospital and Surgical Equipment and Supplies--Rented to Others')
GL_ISO_CODES.set(15314, 'Medical, Hospital and Surgical Supply Stores')
GL_ISO_CODES.set(15404, 'Metal Dealers or Distributors--Nonstructural')
GL_ISO_CODES.set(15405, 'Metal Dealers or Distributors--Structural')
GL_ISO_CODES.set(15406, 'Metal Scrap Dealers')
GL_ISO_CODES.set(15488, 'Mobile Home Sales Agencies')
GL_ISO_CODES.set(15538, 'Musical Instrument Stores')
GL_ISO_CODES.set(15600, 'Nail Salons')
GL_ISO_CODES.set(15607, 'Newspaper or Magazine Distributors')
GL_ISO_CODES.set(15608, 'Newsstands')
GL_ISO_CODES.set(15656, 'Nightclubs, Cabarets and Comedy Clubs')
GL_ISO_CODES.set(15699, 'Nursery--Garden')
GL_ISO_CODES.set(15733, 'Oil Refineries')
GL_ISO_CODES.set(15839, 'Optical Goods Stores')
GL_ISO_CODES.set(15991, 'Paint, Wallpaper or Wallcovering Stores')
GL_ISO_CODES.set(15993, 'Painting, Picture or Frame Stores')
GL_ISO_CODES.set(16005, 'Paper Products Distributors')
GL_ISO_CODES.set(16009, 'Paper, Rag or Rubber Stock Dealers and Distributors--Secondhand')
GL_ISO_CODES.set(16402, 'Pet Grooming')
GL_ISO_CODES.set(16403, 'Pet Stores')
GL_ISO_CODES.set(16404, 'Pet Training')
GL_ISO_CODES.set(16471, 'Photographers')
GL_ISO_CODES.set(16501, 'Plastic or Rubber Supply Goods Distributors')
GL_ISO_CODES.set(16527, 'Plumbing Supplies and Fixtures Dealers and Distributors')
GL_ISO_CODES.set(16588, 'Printers or Electrotypers Supplies--Distributors')
GL_ISO_CODES.set(16604, 'Produce Handling or Packing')
GL_ISO_CODES.set(16670, 'Racquet Sports and Handball Facilities--Commercially Operated')
GL_ISO_CODES.set(16676, 'Music Stores--Pre-Recorded')
GL_ISO_CODES.set(16694, 'Recreational Vehicle Dealers')
GL_ISO_CODES.set(16705, 'Refrigeration Equipment--Dealers and Distributors Only--Commercial')
GL_ISO_CODES.set(16722, 'Rental Stores')
GL_ISO_CODES.set(16723, 'Rental Stores--Machinery or Equipment--Rented to Others on a Long-Term Basis')
GL_ISO_CODES.set(16750, 'Internet Retailers')
GL_ISO_CODES.set(16751, 'Internet Auctions')
GL_ISO_CODES.set(16819, 'Restaurants--Operated by Concessionaires--Other Than Not-For-Profit')
GL_ISO_CODES.set(16820, 'Restaurants--Operated by Concessionaires--Not-For-Profit Only')
GL_ISO_CODES.set(16881, 'Secondhand or Salvage Dealers and Distributors')
GL_ISO_CODES.set(16890, 'Seed Merchants--Excluding Erroneous Delivery, Error in Mixture and Germination Failure')
GL_ISO_CODES.set(16891, 'Seed Merchants--Erroneous Delivery, Error in Mixture and Resulting Germination Failure')
GL_ISO_CODES.set(16892, 'Seed Merchants--Erroneous Delivery, and Error in Mixture (Excluding Germination Failure)')
GL_ISO_CODES.set(16900, 'Restaurants--with No Sale of Alcoholic Beverages--with Table Service')
GL_ISO_CODES.set(16901, 'Restaurants--with No Sale of Alcoholic Beverages--without Table Service with Seating')
GL_ISO_CODES.set(16902, 'Restaurants--with No Sale of Alcoholic Beverages--without Seating')
GL_ISO_CODES.set(
  16910,
  'Restaurants--with Sale of Alcoholic Beverages that are Less Than 30% of the Annual Receipts of the Restaurants--with Table Service'
)
GL_ISO_CODES.set(
  16911,
  'Restaurants--with Sale of Alcoholic Beverages that are Less Than 30% of the Annual Receipts of the Restaurants--without Table Service with Seating'
)
GL_ISO_CODES.set(
  16915,
  'Restaurants--with Sale of Alcoholic Beverages that are 30% or More of But Less Than 75% of the Total Annual Receipts of the Restaurants--with Dance Floor'
)
GL_ISO_CODES.set(
  16916,
  'Restaurants--with Sale of Alcoholic Beverages that are 30% or More of But Less Than 75% of the Total Annual Receipts of the Restaurants--without Dance Floor'
)
GL_ISO_CODES.set(
  16920,
  'Restaurants--with Sale of Alcoholic Beverages that are 75% or More of Total Annual Receipts of the Restaurants--with Tables--with Dance Floor: Table Service'
)
GL_ISO_CODES.set(
  16921,
  'Restaurants--with Sale of Alcoholic Beverages that are 75% or More of Total Annual Receipts of the Restaurants--with Tables--with Dance Floor: No Table Service'
)
GL_ISO_CODES.set(
  16930,
  'Restaurants--with Sale of Alcoholic Beverages that are 75% or More of Total Annual Receipts of the Restaurants--with Tables--without Dance Floor: Table Service'
)
GL_ISO_CODES.set(
  16931,
  'Restaurants--with Sale of Alcoholic Beverages that are 75% or More of Total Annual Receipts of the Restaurants--with Tables--without Dance Floor: No Table Service'
)
GL_ISO_CODES.set(
  16940,
  'Restaurants--with Sale of Alcoholic Beverages that are 75% or More of Total Annual Receipts of the Restaurants--Bar Service Only (No Tables): with Dance Floor'
)
GL_ISO_CODES.set(
  16941,
  'Restaurants--with Sale of Alcoholic Beverages that are 75% or More of Total Annual Receipts of the Restaurants--Bar Service Only (No Tables): without Dance Floor'
)
GL_ISO_CODES.set(18078, 'Ship Chandler Stores')
GL_ISO_CODES.set(18109, 'Shoe Repair Shops')
GL_ISO_CODES.set(18110, 'Shoe Stores')
GL_ISO_CODES.set(18200, 'Spas or Personal Enhancement Facilities')
GL_ISO_CODES.set(18205, 'Sporting Goods or Athletic Equipment Distributors')
GL_ISO_CODES.set(18206, 'Sporting Goods or Athletic Equipment Stores')
GL_ISO_CODES.set(18335, 'Stationery or Paper Products Stores')
GL_ISO_CODES.set(18435, 'Stores--Food or Drink--Other Than Not-For-Profit')
GL_ISO_CODES.set(18436, 'Stores--Food or Drink--Not-For-Profit Only')
GL_ISO_CODES.set(18437, 'Stores: Retail NOC')
GL_ISO_CODES.set(18438, 'Stores--No Food or Drink--Not-For-Profit Only')
GL_ISO_CODES.set(18501, 'Supermarkets')
GL_ISO_CODES.set(18506, 'Tailor Merchants--Men or Boys')
GL_ISO_CODES.set(18507, 'Tailoring or Dressmaking Establishments--Custom')
GL_ISO_CODES.set(18570, 'Tattoo Parlors')
GL_ISO_CODES.set(18575, 'Telecommunication Equipment Providers')
GL_ISO_CODES.set(18616, 'Tire Dealers')
GL_ISO_CODES.set(18707, 'Tobacco Products Distributors')
GL_ISO_CODES.set(18708, 'Tobacco Products Stores')
GL_ISO_CODES.set(18833, 'Toy Distributors')
GL_ISO_CODES.set(18834, 'Toy Stores')
GL_ISO_CODES.set(18911, 'Variety Stores--Other Than Not-For-Profit')
GL_ISO_CODES.set(18912, 'Variety Stores--Not-For-Profit Only')
GL_ISO_CODES.set(18920, 'Video Stores')
GL_ISO_CODES.set(18991, 'Warehouses--Mini-Warehouses')
GL_ISO_CODES.set(19007, 'Washing Machines, Dryers or Ironers--Coin Meter Type')
GL_ISO_CODES.set(19051, 'Water Softening Equipment--Rented to Others')
GL_ISO_CODES.set(19061, 'Portable Toilet Rentals')
GL_ISO_CODES.set(19795, 'Trailer Dealers')
GL_ISO_CODES.set(19796, 'Trailer Rental Agencies')
GL_ISO_CODES.set(40005, 'Adult Day Care--Not-For-Profit Only')
GL_ISO_CODES.set(40006, 'Adult Day Care--Other Than Not-For-Profit')
GL_ISO_CODES.set(40010, 'Airports--Commercial')
GL_ISO_CODES.set(40015, 'Airports--Private')
GL_ISO_CODES.set(40020, 'Airport Control Towers--Not Operated Exclusively by the Federal Aviation Administration')
GL_ISO_CODES.set(
  40026,
  'Airport--Lessees of Portions of Airports Engaged in the Sale of Aircraft or Accessories, Servicing or Repairing of Aircraft or Pilot Instructions'
)
GL_ISO_CODES.set(40031, 'Ambulance Service, First Aid or Rescue Squads--Other Than Not-For-Profit')
GL_ISO_CODES.set(40032, 'Ambulance Service, First Aid or Rescue Squads--Not-For-Profit Only')
GL_ISO_CODES.set(40040, 'Amusement Devices')
GL_ISO_CODES.set(40041, 'Amusement Devices--Operated in Connection with Carnivals or Fairs--Other Than Not-For-Profit')
GL_ISO_CODES.set(40042, 'Amusement Devices--Operated in Connection with Carnivals or Fairs--Not-For-Profit Only')
GL_ISO_CODES.set(40045, 'Animals--Draft')
GL_ISO_CODES.set(40046, 'Animals--Saddle--for Rent')
GL_ISO_CODES.set(40047, 'Animals--Saddle--Private')
GL_ISO_CODES.set(40059, 'Athletic Games Sponsored by the Insured--Other Than Not-For-Profit')
GL_ISO_CODES.set(40061, 'Athletic Games Sponsored by the Insured--Not-For-Profit Only')
GL_ISO_CODES.set(40063, 'Athletic or Sports Contests--in Buildings--Lessees--Other Than Not-For-Profit')
GL_ISO_CODES.set(40064, 'Athletic or Sports Contests--in Buildings--Lessees--Not-For-Profit Only')
GL_ISO_CODES.set(40066, 'Athletic Programs--Amateur--Other Than Not-For-Profit')
GL_ISO_CODES.set(40067, 'Athletic Programs--Amateur--Not-For-Profit Only')
GL_ISO_CODES.set(40069, 'Athletic Teams--Professional or Semi-Professional')
GL_ISO_CODES.set(40072, 'Beaches--Bathing--Not Commercially Operated')
GL_ISO_CODES.set(40075, 'Bingo Games--in Public Halls or Theaters--Commercially Operated')
GL_ISO_CODES.set(40101, 'Blood Banks--Other Than Not-For-Profit')
GL_ISO_CODES.set(40102, 'Blood Banks--Not-For-Profit Only')
GL_ISO_CODES.set(40111, 'Boats--Canoes or Rowboats--Not for Rent--Not Equipped with Motors')
GL_ISO_CODES.set(40115, 'Boats--Motor or Sail--Not for Rent')
GL_ISO_CODES.set(40117, 'Boats--Not for Rent')
GL_ISO_CODES.set(40140, 'Boats--Nonowned over 26 Feet')
GL_ISO_CODES.set(41001, 'Boy or Girl Scout Councils')
GL_ISO_CODES.set(41210, 'Bus Stations or Terminals')
GL_ISO_CODES.set(41421, 'Camps--For-Profit')
GL_ISO_CODES.set(41422, 'Camps--Not-For-Profit')
GL_ISO_CODES.set(41510, 'Caves--Tourist Attraction')
GL_ISO_CODES.set(41603, 'Cemeteries--Other Than Not-For-Profit')
GL_ISO_CODES.set(41604, 'Cemeteries--Not-For-Profit Only')
GL_ISO_CODES.set(41650, 'Churches or Other Houses of Worship')
GL_ISO_CODES.set(41664, 'Clubs--Horseback Riding--No Commercial Riding Instructions')
GL_ISO_CODES.set(41665, 'Clubs--Racket Sports and Handball')
GL_ISO_CODES.set(41666, 'Clubs--Swimming')
GL_ISO_CODES.set(41667, 'Clubs--Civic, Service or Social--Having Buildings or Premises Owned or Leased--Other Than Not-For-Profit')
GL_ISO_CODES.set(41668, 'Clubs--Civic, Service or Social--Having Buildings or Premises Owned or Leased--Not-For-Profit Only')
GL_ISO_CODES.set(
  41670,
  'Clubs--Civic, Service or Social--No Buildings or Premises Owned or Leased Except for Office Purposes--Not-For-Profit Only'
)
GL_ISO_CODES.set(41672, "Conventions (Sponsor's Risk Only)--Other Than Not-For-Profit")
GL_ISO_CODES.set(41673, "Conventions (Sponsor's Risk Only)--Not-For-Profit Only")
GL_ISO_CODES.set(41675, 'Computer Consulting or Programming')
GL_ISO_CODES.set(41677, 'Consultants')
GL_ISO_CODES.set(41678, 'Community Recreational Facilities--Not Operated by Governmental Agency')
GL_ISO_CODES.set(41679, 'Cotton Gin Operations--Other Than Those Performed for a Fee Per Bale')
GL_ISO_CODES.set(41680, 'Convents or Monasteries')
GL_ISO_CODES.set(41696, 'Crematories--Other Than Not-For-Profit')
GL_ISO_CODES.set(41697, 'Crematories--Not-For-Profit Only')
GL_ISO_CODES.set(41700, 'Dam, Levee or Dike--Existence Hazard Only')
GL_ISO_CODES.set(41715, 'Day Care Centers--Other Than Not-For-Profit')
GL_ISO_CODES.set(41716, 'Camps--Not-For-Profit Only')
GL_ISO_CODES.set(43007, 'Drawbridges--Existence Hazard Only')
GL_ISO_CODES.set(43117, 'Dude Ranches')
GL_ISO_CODES.set(43151, 'Computer Data Processing--Operations')
GL_ISO_CODES.set(43152, 'Computer Data Processing--Time Sharing')
GL_ISO_CODES.set(43200, 'Employment Agencies')
GL_ISO_CODES.set(43215, "Entertainment Performed on Others' Premises")
GL_ISO_CODES.set(
  43421,
  'Exhibitions--Outside--In Stadiums or on Premises Having Grandstands or Bleachers Not Erected by or for Insured--Ushers or Other Attendants in Stands Not Provided by Insured'
)
GL_ISO_CODES.set(
  43422,
  'Exhibitions--Outside--In Stadiums or on Premises Having Grandstands or Bleachers Not Erected by or for the Insured--Ushers or Other Attendants in Stands Provided by the Insured'
)
GL_ISO_CODES.set(43424, 'Exhibitions--Outside--No Stadiums or Grandstands')
GL_ISO_CODES.set(43470, 'Pest Control Services')
GL_ISO_CODES.set(43517, 'Fair Grounds--Nonoperating Season')
GL_ISO_CODES.set(43518, "Fairs--Outside (Operator's Risk Only)")
GL_ISO_CODES.set(43550, 'Fire Departments--Other Than Volunteer')
GL_ISO_CODES.set(43551, 'Fire Departments--Volunteer')
GL_ISO_CODES.set(43626, "Fireworks Exhibitions--Contractor's Risk Only")
GL_ISO_CODES.set(43628, "Fireworks Exhibitions--Sponsor's Risk Only--Other Than Not-For-Profit")
GL_ISO_CODES.set(43629, "Fireworks Exhibitions--Sponsor's Risk Only--Not-For-Profit Only")
GL_ISO_CODES.set(43754, 'Fishing Piers')
GL_ISO_CODES.set(43760, 'Fishing Ponds or Lakes--Commercially Operated')
GL_ISO_CODES.set(43822, 'Forestry Service')
GL_ISO_CODES.set(43840, 'Fruit or Vegetable--Harvesting Contractors')
GL_ISO_CODES.set(43860, 'Fumigating')
GL_ISO_CODES.set(43889, 'Funeral Homes or Chapels')
GL_ISO_CODES.set(43945, 'Garbage or Refuse Dumps')
GL_ISO_CODES.set(43946, 'Garbage Works--Separation for Recycling, Reduction or Incineration')
GL_ISO_CODES.set(43990, 'Gambling--Casinos')
GL_ISO_CODES.set(43991, 'Gambling--Incidental to Other Operations')
GL_ISO_CODES.set(44009, "Gasoline or Oil Supply Stations--Retail--(Lessor's Risk Only)")
GL_ISO_CODES.set(44010, 'Gasoline Recovery--from Casing Head or Natural Gas')
GL_ISO_CODES.set(44069, 'Golf Courses--Miniature')
GL_ISO_CODES.set(44070, 'Golf Courses--Municipal or Public--Not Golf or Country Clubs')
GL_ISO_CODES.set(44071, 'Golf Driving Ranges')
GL_ISO_CODES.set(44072, 'Golfmobiles--Loaned or Rented to Others')
GL_ISO_CODES.set(44100, 'Governmental: Municipalities--Population under 2,500')
GL_ISO_CODES.set(44101, 'Governmental: Municipalities--Population 2,501-10,000')
GL_ISO_CODES.set(44102, 'Governmental: Municipalities--Population 10,001-25,000')
GL_ISO_CODES.set(44103, 'Governmental: Municipalities--Population 25,001-50,000')
GL_ISO_CODES.set(44104, 'Governmental: Municipalities--Population 50,001-100,000')
GL_ISO_CODES.set(44105, 'Governmental: Municipalities')
GL_ISO_CODES.set(44106, 'Governmental: Municipalities--Population over 250,000')
GL_ISO_CODES.set(44108, 'Governmental: Counties or Parishes--Population under 10,000')
GL_ISO_CODES.set(44109, 'Governmental: Counties or Parishes--Population 10,001-25,000')
GL_ISO_CODES.set(44110, 'Governmental: Counties or Parishes--Population 25,001-50,000')
GL_ISO_CODES.set(44111, 'Governmental: Counties or Parishes--Population 50,001-100,000')
GL_ISO_CODES.set(44112, 'Governmental: Counties or Parishes--Population 100,001-250,000')
GL_ISO_CODES.set(44113, 'Governmental: Counties or Parishes--Population over 250,000')
GL_ISO_CODES.set(44193, 'Grandstands or Bleachers--Other Than Not-For-Profit')
GL_ISO_CODES.set(44194, 'Grandstands or Bleachers--Not-For-Profit Only')
GL_ISO_CODES.set(44222, 'Guides or Outfitters')
GL_ISO_CODES.set(44276, 'Halls--Other Than Not-For-Profit')
GL_ISO_CODES.set(44277, 'Halls--Not-For-Profit Only')
GL_ISO_CODES.set(44280, 'Event, Party or Wedding Planners')
GL_ISO_CODES.set(44311, 'Health or Exercise Clubs')
GL_ISO_CODES.set(44315, 'Health or Exercise Facilities--Commercially Operated')
GL_ISO_CODES.set(44427, 'Health Care Facilities--Alcohol and Drug--Other Than Not-For-Profit')
GL_ISO_CODES.set(44428, 'Health Care Facilities--Alcohol and Drug--Not-For-Profit Only')
GL_ISO_CODES.set(
  44429,
  'Health Care Facilities--Convalescent or Nursing Homes--Not Mental--Psychopathic Institutions--Other Than Not-For-Profit'
)
GL_ISO_CODES.set(44430, 'Health Care Facilities--Convalescent or Nursing Homes--Not Mental--Psychopathic Institutions--Not-For-Profit Only')
GL_ISO_CODES.set(44431, 'Health Care Facilities--Homes for the Aged--Other Than Not-For-Profit')
GL_ISO_CODES.set(44432, 'Health Care Facilities--Homes for the Aged--Not-For-Profit Only')
GL_ISO_CODES.set(44433, 'Health Care Facilities--Homes for the Physically Handicapped or Orphaned--Other Than Not-For-Profit')
GL_ISO_CODES.set(44434, 'Health Care Facilities--Homes for the Physically Handicapped or Orphaned--Not-For-Profit Only')
GL_ISO_CODES.set(44435, 'Health Care Facilities--Hospitals Other Than Not-For-Profit')
GL_ISO_CODES.set(44436, 'Health Care Facilities--Hospitals Not-For-Profit Only')
GL_ISO_CODES.set(44437, 'Health Care Facilities--Mental--Psychopathic Institutions--Other Than Not-For-Profit')
GL_ISO_CODES.set(44438, 'Health Care Facilities--Mental--Psychopathic Institutions--Not-For-Profit Only')
GL_ISO_CODES.set(
  44439,
  'Health Care Facilities--Clinics, Dispensaries or Infirmaries Treating Outpatients Only--No Regular Bed and Board Facilities--Other Than Not-For-Profit'
)
GL_ISO_CODES.set(
  44440,
  'Health Care Facilities--Clinics, Dispensaries or Infirmaries Treating Outpatients Only--No Regular Bed and Board Facilities--Not-For-Profit Only'
)
GL_ISO_CODES.set(44500, 'Home Health Care Services--Not-For-Profit Only')
GL_ISO_CODES.set(44501, 'Home Health Care Services--Other Than Not-For-Profit')
GL_ISO_CODES.set(45190, 'Hotels and Motels--with Pools or Beaches--Less Than Four Stories')
GL_ISO_CODES.set(45191, 'Hotels and Motels--with Pools or Beaches--Four Stories or More')
GL_ISO_CODES.set(45192, 'Hotels and Motels--without Pools or Beaches--Less Than Four Stories')
GL_ISO_CODES.set(45193, 'Hotels and Motels--without Pools or Beaches--Four Stories or More')
GL_ISO_CODES.set(45210, 'Bed and Breakfasts')
GL_ISO_CODES.set(45224, 'Hunting Preserves--Other Than Not-For-Profit')
GL_ISO_CODES.set(45225, 'Hunting Preserves--Not-For-Profit Only')
GL_ISO_CODES.set(45334, 'Insurance Agents')
GL_ISO_CODES.set(45380, 'Junk Dealers')
GL_ISO_CODES.set(45450, 'Kennels--Breeding, Boarding or Sales')
GL_ISO_CODES.set(45523, 'Lakes or Reservoirs--Existence Hazard Only--Other Than Not-For-Profit')
GL_ISO_CODES.set(45524, 'Lakes or Reservoirs--Existence Hazard Only--Not-For-Profit Only')
GL_ISO_CODES.set(45539, "Land--Occupied by Persons Other Than the Insured for Business Purposes--(Lessor's Risk Only)")
GL_ISO_CODES.set(45678, 'Laundries and Dry Cleaning Plants')
GL_ISO_CODES.set(45771, 'Livestock Sales Companies')
GL_ISO_CODES.set(45819, 'Lumberyards')
GL_ISO_CODES.set(45900, 'Mail Order or Online Drug Stores')
GL_ISO_CODES.set(45901, 'Mail Order Houses')
GL_ISO_CODES.set(45937, 'Mailing or Addressing Companies')
GL_ISO_CODES.set(45993, "Manufacturers' Representatives")
GL_ISO_CODES.set(46004, 'Mausoleums--Other Than Not-For-Profit')
GL_ISO_CODES.set(46005, 'Mausoleums--Not-For-Profit Only')
GL_ISO_CODES.set(46112, 'Diagnostic Testing Laboratories')
GL_ISO_CODES.set(46202, 'Mobile Home Parks or Courts')
GL_ISO_CODES.set(46362, 'Model Homes')
GL_ISO_CODES.set(46426, 'Museums--Other Than Not-For-Profit')
GL_ISO_CODES.set(46427, 'Museums--Not-For-Profit Only')
GL_ISO_CODES.set(46510, 'Oil or Gas Wells--Non-Operating Working Interest')
GL_ISO_CODES.set(46590, 'Parades')
GL_ISO_CODES.set(46603, 'Parking--Public--Not Open Air')
GL_ISO_CODES.set(46604, 'Parking--Public--Open Air')
GL_ISO_CODES.set(46606, "Parking--Public--Shopping Centers--Maintained by Lessee (Lessor's Risk Only)")
GL_ISO_CODES.set(46607, "Parking--Public--Shopping Centers--Maintained by the Insured (Lessor's Risk Only)")
GL_ISO_CODES.set(46622, 'Parking--Private')
GL_ISO_CODES.set(46671, 'Parks or Playgrounds')
GL_ISO_CODES.set(46700, 'Penal Institutions')
GL_ISO_CODES.set(46773, 'Picnic Grounds--Commercially Operated')
GL_ISO_CODES.set(46822, 'Political Campaign Headquarters or Offices')
GL_ISO_CODES.set(
  46881,
  'Professional and Trade Associations--No Buildings or Premises Owned or Leased Except as Offices--Other Than Not - For - Profit'
)
GL_ISO_CODES.set(
  46882,
  'Professional and Trade Associations--No Buildings or Premises Owned or Leased Except as Offices--Not-For-Profit Only'
)
GL_ISO_CODES.set(46911, 'Race Tracks--Motorized Vehicles--Operators')
GL_ISO_CODES.set(46912, 'Race Tracks--Operators')
GL_ISO_CODES.set(46913, "Race Tracks--Motorized Vehicles--Lessor's Risk Only")
GL_ISO_CODES.set(46914, "Racing--Lessor's Risk Only")
GL_ISO_CODES.set(46915, "Race Tracks--Motorized Vehicles--Sponsor's Risk Only")
GL_ISO_CODES.set(46916, "Racing--Sponsor's Risk Only")
GL_ISO_CODES.set(47050, 'Real Estate Agents')
GL_ISO_CODES.set(47051, 'Real Estate Development Property')
GL_ISO_CODES.set(47052, 'Real Estate Property Managed')
GL_ISO_CODES.set(47103, 'Recording Studios')
GL_ISO_CODES.set(47146, 'Recycling Collection Centers--Other Than Not-For-Profit')
GL_ISO_CODES.set(47147, 'Recycling Collection Centers--Not-For-Profit Only')
GL_ISO_CODES.set(47221, 'Riding Academies')
GL_ISO_CODES.set(47253, 'Rifle or Pistol Ranges--Indoor')
GL_ISO_CODES.set(47254, 'Rifle or Pistol Ranges')
GL_ISO_CODES.set(47318, 'Rodeos')
GL_ISO_CODES.set(47367, 'Sales or Service Organizations')
GL_ISO_CODES.set(47420, 'Saunas and Baths--Public')
GL_ISO_CODES.set(47468, 'Schools--Correspondence')
GL_ISO_CODES.set(47469, 'Schools--Faculty Liability for Corporal Punishment of Students')
GL_ISO_CODES.set(47471, 'Schools--Public--Elementary, Kindergarten or Junior High')
GL_ISO_CODES.set(47473, 'Schools--Public--High')
GL_ISO_CODES.set(47474, 'Schools--Trade or Vocational')
GL_ISO_CODES.set(47475, 'Schools--Private--Elementary, Kindergarten or Junior High--Other Than Not-For-Profit')
GL_ISO_CODES.set(47476, 'Schools--Private--Elementary, Kindergarten or Junior High--Not-For-Profit Only')
GL_ISO_CODES.set(47477, 'Schools--Private--High--Other Than Not-For-Profit')
GL_ISO_CODES.set(47478, 'Schools--Private--High--Not-For-Profit Only')
GL_ISO_CODES.set(47610, 'Internet Service Providers')
GL_ISO_CODES.set(48039, 'Sewers')
GL_ISO_CODES.set(48177, 'Skating Rinks--Ice')
GL_ISO_CODES.set(48178, 'Skating Rinks--Roller')
GL_ISO_CODES.set(48206, 'Skeet Shooting or Trap Shooting Ranges')
GL_ISO_CODES.set(48252, 'Ski Lifts, Tows or Runs')
GL_ISO_CODES.set(48441, 'Soap Box Derbies')
GL_ISO_CODES.set(48557, 'Social Gatherings and Meetings--on Premises Not Owned or Operated by the Insured--Other Than Not-For-Profit')
GL_ISO_CODES.set(48558, 'Social Gatherings and Meetings--on Premises Not Owned or Operated by the Insured--Not-For-Profit Only')
GL_ISO_CODES.set(48600, 'Social Services--Consulting Services Only--Operated by the Private Sector')
GL_ISO_CODES.set(48610, 'Sports or Outdoor Activities--Commercially Operated')
GL_ISO_CODES.set(48636, 'Stockyards')
GL_ISO_CODES.set(48637, 'Stadiums--Operated by Insured--Other Than Not-For-Profit')
GL_ISO_CODES.set(48638, 'Stadiums--Operated by Insured--Not-For-Profit Only')
GL_ISO_CODES.set(48727, 'Streets, Roads, Highways or Bridges--Existence and Maintenance Hazard Only')
GL_ISO_CODES.set(48808, 'Sun Tanning Salons')
GL_ISO_CODES.set(48924, 'Swimming Pools--Commercially Operated')
GL_ISO_CODES.set(48925, 'Swimming Pools')
GL_ISO_CODES.set(49005, 'Taxidermists')
GL_ISO_CODES.set(49111, 'Tents or Canopies--Loaned or Rented to Others')
GL_ISO_CODES.set(49181, 'Theaters--Drive-In')
GL_ISO_CODES.set(49183, 'Theaters--Motion Pictures')
GL_ISO_CODES.set(49184, 'Theaters--Other Than Not-For-Profit Only')
GL_ISO_CODES.set(49185, 'Theaters--Not-For-Profit Only')
GL_ISO_CODES.set(49239, 'Tire--Retreading or Recapping')
GL_ISO_CODES.set(49292, 'Toll Bridges')
GL_ISO_CODES.set(49305, 'Towers--Telecommunication--Existence Hazard Only (Lessors Risk Only)')
GL_ISO_CODES.set(49333, 'Travel Agency Tours')
GL_ISO_CODES.set(49451, 'Vacant Land--Other Than Not-For-Profit')
GL_ISO_CODES.set(49452, 'Vacant Land--Not-For-Profit Only')
GL_ISO_CODES.set(49617, 'Vending Machine Operations--Confection, Food, Beverage or Ice')
GL_ISO_CODES.set(49618, 'Vending Machine Operations--Tobacco Products')
GL_ISO_CODES.set(49619, 'Vending Machine Operations')
GL_ISO_CODES.set(49763, 'Warehouse--Cold Individual Storage Lockers')
GL_ISO_CODES.set(49800, 'Wharf and Waterfront Property--Ferry Docks or Terminals')
GL_ISO_CODES.set(49801, 'Wharf and Waterfront Property--Occupied by the Insured for Both Freight and Passenger Purposes')
GL_ISO_CODES.set(49802, "Wharf and Waterfront Property--Not Occupied by the Insured (Lessor's Risk Only)")
GL_ISO_CODES.set(49803, 'Wharf and Waterfront Property--Occupied by the Insured for Freight Purposes Exclusively')
GL_ISO_CODES.set(49840, 'Window Decorating')
GL_ISO_CODES.set(49870, 'YMCA, YWCA or Similar Institutions')
GL_ISO_CODES.set(49890, 'Youth Recreation Programs--Other Than Not-For-Profit')
GL_ISO_CODES.set(49891, 'Youth Recreation Programs--Not-For-Profit Only')
GL_ISO_CODES.set(49902, 'Zoos--Other Than Not-For-Profit')
GL_ISO_CODES.set(49903, 'Zoos--Not-For-Profit Only')
GL_ISO_CODES.set(50010, 'Abrasive Wheel Mfg.')
GL_ISO_CODES.set(50015, 'Abrasives or Abrasive Products Mfg.--Artificial')
GL_ISO_CODES.set(50017, 'Abrasives or Abrasive Products Mfg.')
GL_ISO_CODES.set(50045, 'Adhesive Mfg.')
GL_ISO_CODES.set(50047, 'Adhesive Tape Mfg.')
GL_ISO_CODES.set(51001, 'Aerosol Container Mfg.')
GL_ISO_CODES.set(51005, 'Aerosol Containers--Filling or Charging for Others')
GL_ISO_CODES.set(51116, 'Air Conditioning Equipment Mfg.')
GL_ISO_CODES.set(51201, 'Aircraft or Aircraft Parts Mfg.')
GL_ISO_CODES.set(51205, 'Alarm Mfg.--Burglar')
GL_ISO_CODES.set(51206, 'Alarm Mfg.--Fire or Smoke')
GL_ISO_CODES.set(51210, 'Alcohol Mfg.--Not Beverage')
GL_ISO_CODES.set(51211, 'Ammunition Mfg.')
GL_ISO_CODES.set(51220, 'Appliances and Accessories Mfg.--Commercial--Gas')
GL_ISO_CODES.set(51221, 'Appliances and Accessories Mfg.--Commercial--Not Gas')
GL_ISO_CODES.set(51222, 'Appliances and Accessories Mfg.--Household--Gas')
GL_ISO_CODES.set(51224, 'Appliances and Accessories Mfg.--Household--Not Gas')
GL_ISO_CODES.set(51230, 'Asbestos Goods Mfg.')
GL_ISO_CODES.set(51240, 'Asphalt or Tar Distilling or Refining')
GL_ISO_CODES.set(51241, 'Asphalt Works')
GL_ISO_CODES.set(51250, 'Automobile, Bus and Truck Body Mfg.')
GL_ISO_CODES.set(51251, 'Automobile, Bus or Truck Parts Mfg.--Brakes or Brake Linings')
GL_ISO_CODES.set(51252, 'Automobile, Bus or Truck Parts Mfg.--Not Operating Parts')
GL_ISO_CODES.set(51253, 'Automobile, Bus or Truck Parts Mfg.--Operating Parts')
GL_ISO_CODES.set(51254, 'Automobile, Bus or Truck Parts Mfg.--Passenger Restraining Devices')
GL_ISO_CODES.set(51255, 'Automobile Mfg. or Assembling')
GL_ISO_CODES.set(51305, 'Baby Food Mfg.')
GL_ISO_CODES.set(51315, 'Bakery Plants')
GL_ISO_CODES.set(51330, 'Battery Mfg.--Dry Cell')
GL_ISO_CODES.set(51333, 'Battery Mfg.--Wet Cell or Storage')
GL_ISO_CODES.set(51340, 'Bearing Mfg.')
GL_ISO_CODES.set(51350, 'Beer, Ale or Malt Liquor Mfg.--In Bottles')
GL_ISO_CODES.set(51351, 'Beer, Ale or Malt Liquor Mfg.--In Cans')
GL_ISO_CODES.set(51352, 'Beer, Ale or Malt Liquor Mfg.--Not Bottled or Canned')
GL_ISO_CODES.set(51355, 'Beverage Bottler--Soft Drinks--Carbonated--In Cans or Plastic Bottles')
GL_ISO_CODES.set(51356, 'Beverage Bottler--Soft Drinks--Carbonated--In Glass Bottles')
GL_ISO_CODES.set(51357, 'Beverage Bottler--Soft Drinks--In Metal Cylinders')
GL_ISO_CODES.set(51358, 'Beverage Bottler--Soft Drinks--In Paper Containers')
GL_ISO_CODES.set(51359, 'Beverage Bottler--Soft Drinks--Not Carbonated--In Bottles or Cans')
GL_ISO_CODES.set(51370, 'Bicycle Mfg.--Not Motorized')
GL_ISO_CODES.set(51380, 'Billiard or Pool Table Mfg.')
GL_ISO_CODES.set(51400, 'Boat or Ship Building--Inboard and Inboard/Outboard')
GL_ISO_CODES.set(51401, 'Boat or Ship Building--without Motors')
GL_ISO_CODES.set(51500, 'Bolt, Nut, Rivet, Screw or Washer Mfg.')
GL_ISO_CODES.set(51516, 'Bookbinding--Other Than Not-For-Profit')
GL_ISO_CODES.set(51517, 'Bookbinding--Not-For-Profit Only')
GL_ISO_CODES.set(51550, 'Bottle and Jar Mfg.--Glass--Not for Use under Pressure')
GL_ISO_CODES.set(51551, 'Bottle and Jar Mfg.--Glass--for Use under Pressure--Nonreturnable')
GL_ISO_CODES.set(51552, 'Bottle and Jar Mfg.--Glass--for Use under Pressure--Returnable')
GL_ISO_CODES.set(51553, 'Bottle and Jar Mfg.--Plastic--Nonreturnable')
GL_ISO_CODES.set(51554, 'Bottle and Jar Mfg.--Plastic--Returnable')
GL_ISO_CODES.set(51575, 'Boxes or Containers Mfg.--Corrugated or Fiberboard')
GL_ISO_CODES.set(51576, 'Boxes or Containers Mfg.--Wood')
GL_ISO_CODES.set(51600, 'Brick Mfg.')
GL_ISO_CODES.set(51613, 'Brush or Broom Mfg.')
GL_ISO_CODES.set(51625, 'Bus Mfg. or Assembling or Reconstruction')
GL_ISO_CODES.set(51666, 'Buttons or Fasteners Mfg.')
GL_ISO_CODES.set(51702, 'Camper Bodies or Camper Trailers Mfg.')
GL_ISO_CODES.set(51703, 'Campers Mfg.--Self-Powered')
GL_ISO_CODES.set(51734, 'Can Mfg.--Metal')
GL_ISO_CODES.set(51741, 'Candle Mfg.')
GL_ISO_CODES.set(51752, 'Candy or Confectionery Products Mfg.')
GL_ISO_CODES.set(51767, 'Carbon Paper or Inked Ribbon Mfg.')
GL_ISO_CODES.set(51777, 'Carpet or Rug Mfg.')
GL_ISO_CODES.set(51790, 'Caulking Compounds, Putty or Similar Products Mfg.')
GL_ISO_CODES.set(51796, 'Cellophane and Cellophane Products Mfg.')
GL_ISO_CODES.set(51808, 'Cement, Concrete Mix or Plaster Mfg.--Packaged')
GL_ISO_CODES.set(51809, 'Cement or Plaster Mfg.--Bulk')
GL_ISO_CODES.set(51833, 'Charcoal or Coal Briquette Mfg.')
GL_ISO_CODES.set(51850, 'Chemical Mfg.--Commercial or Industrial')
GL_ISO_CODES.set(51851, 'Chemical Mfg.--Commercial or Industrial--Toxic and Either Flammable, Explosive or Reactive')
GL_ISO_CODES.set(51852, 'Chemical Mfg.--Commercial or Industrial--Primarily Flammable, Explosive or Reactive')
GL_ISO_CODES.set(51853, 'Chemical Mfg.--Commercial or Industrial--Primarily Toxic or Presenting a Health Hazard')
GL_ISO_CODES.set(51854, 'Chemical Mfg.--Household--Toxic and Either Flammable, Explosive or Reactive')
GL_ISO_CODES.set(51855, 'Chemical Mfg.--Household')
GL_ISO_CODES.set(51856, 'Chemical Mfg.--Household--Primarily Flammable, Explosive or Reactive')
GL_ISO_CODES.set(51857, 'Chemical Mfg.--Household--Primarily Toxic or Presenting a Health Hazard')
GL_ISO_CODES.set(51869, 'China, Porcelain or Earthenware Mfg.')
GL_ISO_CODES.set(51877, 'Clay Products Mfg.')
GL_ISO_CODES.set(51889, 'Clock Mfg.')
GL_ISO_CODES.set(51896, 'Clothing Mfg.')
GL_ISO_CODES.set(51900, 'Coffins or Caskets Mfg.')
GL_ISO_CODES.set(51909, 'Coke Mfg.')
GL_ISO_CODES.set(51919, 'Color or Pigment Preparation')
GL_ISO_CODES.set(51926, 'Communication or Recording Systems or Equipment Mfg.--Industrial or Commercial')
GL_ISO_CODES.set(51927, 'Communication or Recording Systems or Equipment Mfg.--Other Than Industrial or Commercial')
GL_ISO_CODES.set(51934, 'Composition Goods Mfg.--Not Floor Coverings')
GL_ISO_CODES.set(51941, 'Computer Mfg.')
GL_ISO_CODES.set(51942, 'Computer Software Mfg.--Pre-Packaged')
GL_ISO_CODES.set(51956, 'Concrete--Mixed in Transit')
GL_ISO_CODES.set(51957, 'Concrete or Plaster Products Mfg.--Not Structural')
GL_ISO_CODES.set(51958, 'Concrete Products Mfg.--Prestressed')
GL_ISO_CODES.set(51959, 'Concrete Products Mfg.--Structural')
GL_ISO_CODES.set(51960, 'Contact Lenses Mfg.')
GL_ISO_CODES.set(51970, 'Cosmetics Mfg.')
GL_ISO_CODES.set(51982, 'Cotton Batting, Wadding or Waste Mfg.')
GL_ISO_CODES.set(51985, 'Cotton Compressing')
GL_ISO_CODES.set(51986, 'Cotton Gin Operations')
GL_ISO_CODES.set(51999, 'Cutlery (Not Powered) and Flatware Mfg.')
GL_ISO_CODES.set(52002, 'Dairy Products Mfg.')
GL_ISO_CODES.set(52075, 'Detergent Mfg.--Household')
GL_ISO_CODES.set(52076, 'Detergent Mfg.--Other Than Household')
GL_ISO_CODES.set(52109, 'Dextrine Mfg.')
GL_ISO_CODES.set(52134, 'Door or Window Mfg.--Other Than Wood')
GL_ISO_CODES.set(52137, 'Die Casting Mfg.')
GL_ISO_CODES.set(52150, 'Distillation or Extraction')
GL_ISO_CODES.set(52315, 'Door or Window Mfg.--Wood')
GL_ISO_CODES.set(52341, 'Drug Mfg.--Biological Products')
GL_ISO_CODES.set(52342, 'Drug, Medicine or Pharmaceutical Preparations Mfg.--for Animal Use')
GL_ISO_CODES.set(52343, 'Drug, Medicine or Pharmaceutical Preparations Mfg.--Other Than for Animal Use')
GL_ISO_CODES.set(52401, 'Drums or Containers Mfg.--Metal')
GL_ISO_CODES.set(52402, 'Drums or Containers Mfg.--Plastic')
GL_ISO_CODES.set(52432, 'Electrical Equipment Mfg.--Other Than for Direct and Indirect Application to the Body')
GL_ISO_CODES.set(52433, 'Electrical Equipment Mfg.--for Direct and Indirect Application to the Body')
GL_ISO_CODES.set(52435, 'Electrical Generating Machinery Mfg.')
GL_ISO_CODES.set(52438, 'Electrical Parts, Components or Accessories Mfg.')
GL_ISO_CODES.set(52440, 'Electrical Power Distribution or Transmission Equipment Mfg.')
GL_ISO_CODES.set(52467, 'Electrical Wire or Cable Mfg.')
GL_ISO_CODES.set(52469, 'Electronic Components Mfg.')
GL_ISO_CODES.set(52505, 'Electronic Games Mfg.')
GL_ISO_CODES.set(52547, 'Electroplating')
GL_ISO_CODES.set(52581, 'Elevator Mfg.')
GL_ISO_CODES.set(52619, 'Engine or Turbine Mfg.--Not Aircraft')
GL_ISO_CODES.set(52660, 'Engraving')
GL_ISO_CODES.set(52744, 'Escalator or Moving Sidewalk Mfg.')
GL_ISO_CODES.set(52767, 'Exercise or Playground Equipment Mfg.')
GL_ISO_CODES.set(52876, 'Explosive or Fireworks Mfg.')
GL_ISO_CODES.set(52911, 'Extracts Mfg.')
GL_ISO_CODES.set(52967, 'Eye Glass Lens Mfg.')
GL_ISO_CODES.set(53001, 'Feed Mfg.')
GL_ISO_CODES.set(53077, 'Fertilizer Mfg.')
GL_ISO_CODES.set(53095, 'Fiber Mfg.--Other Than Synthetic')
GL_ISO_CODES.set(53096, 'Fiber Mfg.--Synthetic')
GL_ISO_CODES.set(53121, 'Fiberglass Mfg.')
GL_ISO_CODES.set(53147, 'Fire Extinguishers Mfg.')
GL_ISO_CODES.set(53229, 'Fire Suppression Systems Mfg.')
GL_ISO_CODES.set(53271, 'Firearms Mfg.')
GL_ISO_CODES.set(53333, 'Floor Covering Mfg.--Not Carpets, Rugs, Ceramic or Stone Tiles')
GL_ISO_CODES.set(53374, 'Food Products Mfg.--Dry')
GL_ISO_CODES.set(53375, 'Food Products Mfg.--Frozen')
GL_ISO_CODES.set(53376, 'Food Products Mfg.--Not Dry--In Glass Containers')
GL_ISO_CODES.set(53377, 'Food Products Mfg.--Not Dry--In Other Than Glass Containers')
GL_ISO_CODES.set(53403, 'Forging Work')
GL_ISO_CODES.set(53425, 'Foundries')
GL_ISO_CODES.set(53565, 'Fruit or Vegetable Juice Mfg.--No Bottling of Carbonated Beverages')
GL_ISO_CODES.set(53631, 'Fur Garment Mfg.')
GL_ISO_CODES.set(53632, 'Fur or Pelt Processing')
GL_ISO_CODES.set(53731, 'Furniture Mfg. or Assembling--Infants')
GL_ISO_CODES.set(53732, 'Furniture Mfg. or Assembling--Other Than Wood')
GL_ISO_CODES.set(53733, 'Furniture Mfg. or Assembling--Wood')
GL_ISO_CODES.set(53734, 'Furniture or Woodwork Stripping, Refinishing or Repairing--Shop Only')
GL_ISO_CODES.set(53803, 'Galvanizing or Tinning')
GL_ISO_CODES.set(53901, 'Gas Mfg.--Toxic and Either Flammable, Explosive or Reactive')
GL_ISO_CODES.set(53902, 'Gas Mfg.--Inert')
GL_ISO_CODES.set(53903, 'Gas Mfg.--Other')
GL_ISO_CODES.set(53904, 'Gas Mfg.--Primarily Flammable, Explosive or Reactive')
GL_ISO_CODES.set(53905, 'Gas Mfg.--Primarily Toxic or Presenting a Health Hazard')
GL_ISO_CODES.set(53907, 'Gasoline Distributors')
GL_ISO_CODES.set(54012, 'Gemstone Cutting or Polishing')
GL_ISO_CODES.set(54077, 'Glass or Glassware Mfg.')
GL_ISO_CODES.set(54444, 'Manufacturers')
GL_ISO_CODES.set(55010, 'Heating Equipment Mfg.--Coal or Wood')
GL_ISO_CODES.set(55011, 'Heating Equipment Mfg.--Electric')
GL_ISO_CODES.set(55012, 'Heating Equipment Mfg.--Fuel Oil or Kerosene')
GL_ISO_CODES.set(55013, 'Heating Equipment Mfg.--Gas or Liquefied Petroleum Gas')
GL_ISO_CODES.set(55214, 'Hone, Oilstone or Whetstone Mfg.')
GL_ISO_CODES.set(55371, 'Honey Extracting')
GL_ISO_CODES.set(55410, 'Importers')
GL_ISO_CODES.set(55426, 'Ink Mfg.')
GL_ISO_CODES.set(55597, 'Inner Tubes Mfg.')
GL_ISO_CODES.set(55647, 'Instrument Mfg.--Analytical, Calibrating, Measuring, Testing or Recording')
GL_ISO_CODES.set(55648, 'Instrument Mfg.--Control')
GL_ISO_CODES.set(55649, 'Instrument Mfg.')
GL_ISO_CODES.set(55715, 'Insulating Material Mfg.--Mineral')
GL_ISO_CODES.set(55716, 'Insulating Material Mfg.--Organic')
GL_ISO_CODES.set(55717, 'Insulating Material Mfg.--Plastic--for Application in a Solid State')
GL_ISO_CODES.set(55718, 'Insulating Material Mfg.--Plastic')
GL_ISO_CODES.set(55802, 'Jewelry Mfg.')
GL_ISO_CODES.set(55918, 'Ladder Mfg.--Other Than Wood')
GL_ISO_CODES.set(55919, 'Ladder Mfg.--Wood')
GL_ISO_CODES.set(56040, 'Lamp Shade Mfg.')
GL_ISO_CODES.set(56041, 'Lamps or Lanterns Mfg.--Electric')
GL_ISO_CODES.set(56042, 'Lamps or Lanterns Mfg.--Other Than Electric')
GL_ISO_CODES.set(56170, 'Lead Mfg.--Red or White')
GL_ISO_CODES.set(56171, 'Lead Works--Sheet, Pipe or Shot')
GL_ISO_CODES.set(56202, 'Leather Goods Mfg.')
GL_ISO_CODES.set(56390, 'Light Bulb or Tubes Mfg.')
GL_ISO_CODES.set(56391, 'Lighting Fixtures Mfg.')
GL_ISO_CODES.set(56427, 'Lime Mfg.')
GL_ISO_CODES.set(56488, 'Liquor Mfg.')
GL_ISO_CODES.set(56567, 'Lubricants Mfg.--Grease')
GL_ISO_CODES.set(56650, 'Machinery or Machinery Parts Mfg.--Construction, Mining or Materials Handling Type')
GL_ISO_CODES.set(56651, 'Machinery or Machinery Parts Mfg.--Farm Type')
GL_ISO_CODES.set(56652, 'Machinery or Machinery Parts Mfg.--Industrial Type')
GL_ISO_CODES.set(56653, 'Machinery or Machinery Parts Mfg.--Metalworking')
GL_ISO_CODES.set(56654, 'Machinery or Machinery Parts Mfg.')
GL_ISO_CODES.set(56690, 'Match Mfg.')
GL_ISO_CODES.set(56699, 'Mattress or Box Spring Mfg.')
GL_ISO_CODES.set(56758, 'Meat, Fish, Poultry or Seafood--Curing')
GL_ISO_CODES.set(56759, 'Meat, Fish, Poultry or Seafood Processing--In Airtight Containers')
GL_ISO_CODES.set(56760, 'Meat, Fish, Poultry or Seafood Processing--Not in Airtight Containers')
GL_ISO_CODES.set(56805, 'Medical, Dental, Hospital or Surgical Equipment or Supplies Mfg.--Expendable')
GL_ISO_CODES.set(56806, 'Medical, Dental, Hospital or Surgical Equipment or Supplies Mfg.--Nonexpendable')
GL_ISO_CODES.set(56807, 'Medical, Dental, Hospital or Surgical Instruments Mfg.')
GL_ISO_CODES.set(56808, 'Medical, Dental or Surgical Diagnostic or Treatment Machines or Devices Mfg.')
GL_ISO_CODES.set(56900, 'Metals--Extraction or Refining')
GL_ISO_CODES.set(56910, 'Metal Foil Mfg.')
GL_ISO_CODES.set(56911, 'Metal Goods Mfg.')
GL_ISO_CODES.set(56912, 'Metal Goods Mfg.--Stamping--Not Signs')
GL_ISO_CODES.set(56913, 'Metal Heat Processing')
GL_ISO_CODES.set(56915, 'Metal Works--Shop--Structural--Load Bearing')
GL_ISO_CODES.set(56916, 'Metal Works--Shop--Structural--Not Load Bearing')
GL_ISO_CODES.set(56917, 'Metals--Extraction or Refining--Chemical Processes')
GL_ISO_CODES.set(56918, 'Metals--Extraction or Refining--Electrometallurgical Processes')
GL_ISO_CODES.set(56919, 'Metals--Extraction or Refining of Ferrous Metals--Blast Furnace or Other Pyrometallurgical Processes')
GL_ISO_CODES.set(56920, 'Metals--Extraction or Refining of Nonferrous Metals--Blast Furnace or Other Pyrometallurgical Processes')
GL_ISO_CODES.set(56980, 'Mica Goods Mfg.')
GL_ISO_CODES.set(57001, 'Milk Depots or Dealers')
GL_ISO_CODES.set(57002, 'Milk Processing')
GL_ISO_CODES.set(57090, 'Mobile Home Mfg.')
GL_ISO_CODES.set(57146, 'Modular Units Mfg.')
GL_ISO_CODES.set(57202, 'Motorcycle, Moped or Motor Scooter Mfg.')
GL_ISO_CODES.set(57257, 'Musical Instrument Mfg.')
GL_ISO_CODES.set(57401, 'Nails or Spikes Mfg.')
GL_ISO_CODES.set(57403, 'Needles, Pins or Tacks Mfg.')
GL_ISO_CODES.set(57410, 'Net Mfg.--Other Than Safety Nets')
GL_ISO_CODES.set(57411, 'Net Mfg.--Safety Nets')
GL_ISO_CODES.set(57572, 'Office Machines Mfg.')
GL_ISO_CODES.set(57600, 'Optical Goods Mfg.')
GL_ISO_CODES.set(57611, 'Ore Milling or Processing')
GL_ISO_CODES.set(57625, 'Orthopedic, Ambulation or Prosthetic Devices Mfg.')
GL_ISO_CODES.set(57651, 'Packing Houses')
GL_ISO_CODES.set(57690, 'Paint, Varnish, Shellac or Lacquer Mfg.')
GL_ISO_CODES.set(57716, 'Paper Coating or Finishing')
GL_ISO_CODES.set(57725, 'Paper Goods Mfg.')
GL_ISO_CODES.set(57726, 'Paper Mfg.')
GL_ISO_CODES.set(57798, 'Parachute Mfg.')
GL_ISO_CODES.set(57800, 'Media Mfg.--Blank')
GL_ISO_CODES.set(57808, 'Pattern Mfg.--Metal')
GL_ISO_CODES.set(57809, 'Pattern Mfg.--Other')
GL_ISO_CODES.set(57810, 'Pattern Mfg.--Paper')
GL_ISO_CODES.set(57871, 'Pencil, Pen, Crayon or Chalk Mfg.')
GL_ISO_CODES.set(57913, 'Pet Food Mfg.')
GL_ISO_CODES.set(57997, 'Photo Finishing Laboratories')
GL_ISO_CODES.set(57998, 'Photographic Equipment Mfg.')
GL_ISO_CODES.set(57999, 'Photographic Supplies Mfg.')
GL_ISO_CODES.set(58009, 'Pipes or Tubes Mfg.--Metal')
GL_ISO_CODES.set(58010, 'Pipes or Tubes Mfg.--Plastic')
GL_ISO_CODES.set(58020, 'Pipes Mfg.--Tobacco')
GL_ISO_CODES.set(58056, 'Plastic Mfg.--Raw Material')
GL_ISO_CODES.set(58057, 'Plastic or Rubber Goods Mfg.--Household')
GL_ISO_CODES.set(58058, 'Plastic or Rubber Goods Mfg.--Other Than Household')
GL_ISO_CODES.set(58095, 'Plumbing Fixtures Mfg.')
GL_ISO_CODES.set(58096, 'Plumbing Supplies Mfg.')
GL_ISO_CODES.set(58301, 'Plywood, Veneer or Veneer Products Mfg.--Other')
GL_ISO_CODES.set(58302, 'Plywood, Veneer or Veneer Products Mfg.--without Log Processing')
GL_ISO_CODES.set(58397, 'Prefabricated Building Mfg.')
GL_ISO_CODES.set(58408, 'Printing--Other Than Not-For-Profit')
GL_ISO_CODES.set(58409, 'Printing--Not-For-Profit Only')
GL_ISO_CODES.set(58456, 'Publishers--Books or Magazines--Other Than Not-For-Profit')
GL_ISO_CODES.set(58457, 'Publishers--Books or Magazines--Not-For-Profit Only')
GL_ISO_CODES.set(58458, 'Publishers--Newspapers--Other Than Not-For-Profit')
GL_ISO_CODES.set(58459, 'Publishers--Newspapers--Not-For-Profit Only')
GL_ISO_CODES.set(58503, 'Pulp Mfg.')
GL_ISO_CODES.set(58532, 'Pumps or Compressors Mfg.')
GL_ISO_CODES.set(58559, 'Railroad Engine Mfg.')
GL_ISO_CODES.set(58560, 'Railroad or Other Public Conveyance Cars Mfg.')
GL_ISO_CODES.set(58561, 'Railroad or Other Public Conveyance Cars Parts Mfg.')
GL_ISO_CODES.set(58575, 'Razor or Razor Blades Mfg.')
GL_ISO_CODES.set(58627, 'Media Mfg.--Pre-Recorded')
GL_ISO_CODES.set(58663, 'Refrigeration Equipment Mfg.')
GL_ISO_CODES.set(58682, 'Rendering Works')
GL_ISO_CODES.set(58713, 'Rolling Mills--Cold or Hot Process')
GL_ISO_CODES.set(58737, 'Rope Mfg.')
GL_ISO_CODES.set(58756, 'Rubber Mfg.')
GL_ISO_CODES.set(58757, 'Rubber Reclaiming')
GL_ISO_CODES.set(58759, 'Rubber Stamp Mfg. or Assembling')
GL_ISO_CODES.set(58802, 'Saddles, Harnesses or Horses Furnishings Mfg.')
GL_ISO_CODES.set(58813, 'Safes or Safe Vaults Mfg.')
GL_ISO_CODES.set(58822, 'Sail Making')
GL_ISO_CODES.set(58837, 'Salt, Borax, Potash or Phosphate--Producing or Refining')
GL_ISO_CODES.set(58840, 'Salt Mfg.')
GL_ISO_CODES.set(58873, 'Saw Mills or Planing Mills')
GL_ISO_CODES.set(58903, 'Sewing Machines Mfg.--Commercial')
GL_ISO_CODES.set(58904, 'Sewing Machines Mfg.--Household')
GL_ISO_CODES.set(58922, 'Sheet Metal Work--Shop Only')
GL_ISO_CODES.set(59005, 'Shoe, Boot or Slipper Mfg.')
GL_ISO_CODES.set(59057, 'Sign Mfg.--Electrical')
GL_ISO_CODES.set(59058, 'Sign Mfg.--Other Than Electrical')
GL_ISO_CODES.set(59188, 'Slate Milling')
GL_ISO_CODES.set(59189, 'Slate Splitting or Slate Roofing Mfg.')
GL_ISO_CODES.set(59223, 'Soap Mfg.')
GL_ISO_CODES.set(59257, 'Sponge Processing')
GL_ISO_CODES.set(59306, 'Sporting Goods or Athletic Equipment Mfg.')
GL_ISO_CODES.set(59378, 'Steel Wool or Wire Wool Mfg.')
GL_ISO_CODES.set(59481, 'Stone Crushing')
GL_ISO_CODES.set(59482, 'Stone Cutting or Polishing')
GL_ISO_CODES.set(59537, 'Sugar Refining')
GL_ISO_CODES.set(59601, 'Swimming Pools or Accessories Mfg.')
GL_ISO_CODES.set(59647, 'Syrups or Molasses--Refining, Blending or Mfg.')
GL_ISO_CODES.set(59660, 'Tank Building or Mfg.--Metal--Not Pressurized')
GL_ISO_CODES.set(59661, 'Tank Building or Mfg.--Metal--Pressurized')
GL_ISO_CODES.set(59693, 'Tanning--Animal Hides')
GL_ISO_CODES.set(59695, 'Telecommunication Equipment Mfg.')
GL_ISO_CODES.set(59701, 'Television Picture Tube Mfg.')
GL_ISO_CODES.set(59713, 'Tent or Canopy Mfg.')
GL_ISO_CODES.set(59722, 'Textile Bleaching, Dyeing, Mercerizing, Printing, Finishing or Silk Screening--New Goods')
GL_ISO_CODES.set(59723, 'Textile Coating or Impregnating')
GL_ISO_CODES.set(59724, 'Textile Mfg.--Impregnated or Coated')
GL_ISO_CODES.set(59725, 'Textile Products Mfg.--Fabricated')
GL_ISO_CODES.set(59726, 'Textile Spinning, Weaving or Knitting Mills')
GL_ISO_CODES.set(59738, 'Tie, Post or Pole Yard')
GL_ISO_CODES.set(59750, 'Tire Mfg.--Auto, Bus or Truck')
GL_ISO_CODES.set(59751, 'Tire Mfg.--Not Auto, Bus or Truck')
GL_ISO_CODES.set(59773, 'Tobacco Products Mfg.--Cigars or Cigarettes')
GL_ISO_CODES.set(59774, 'Tobacco Products Mfg.--Other')
GL_ISO_CODES.set(59775, 'Tobacco Products Mfg.--Plug or Snuff')
GL_ISO_CODES.set(59781, 'Tool Mfg.--Accessories')
GL_ISO_CODES.set(59782, 'Tool Mfg.--Hand Type--Not Powered')
GL_ISO_CODES.set(59783, 'Tool Mfg.--Hand Type--Powered')
GL_ISO_CODES.set(59784, 'Tool Mfg.--Power Equipment--Household Type--Outdoor or Workshop')
GL_ISO_CODES.set(59790, 'Toys or Games Mfg.')
GL_ISO_CODES.set(59798, 'Trailers Mfg.')
GL_ISO_CODES.set(59806, 'Truck Mfg. or Assembling')
GL_ISO_CODES.set(59867, 'Turpentine or Resin Mfg.')
GL_ISO_CODES.set(59886, 'Twine or Cordage Mfg.')
GL_ISO_CODES.set(59889, 'Umbrella or Cane Mfg.')
GL_ISO_CODES.set(59892, 'Valves Mfg.')
GL_ISO_CODES.set(59904, 'Vegetable Oil Mfg.--By Solvent Extraction')
GL_ISO_CODES.set(59905, 'Vegetable Oil Mfg.')
GL_ISO_CODES.set(59914, 'Metal Works--Shop--Decorative or Artistic')
GL_ISO_CODES.set(59915, 'Vending Machines Mfg.')
GL_ISO_CODES.set(59917, 'Venetian Blinds Mfg. or Assembling')
GL_ISO_CODES.set(59923, 'Watch or Watch Case Mfg.')
GL_ISO_CODES.set(59925, 'Water Bottling--In Siphons')
GL_ISO_CODES.set(59926, 'Water Bottling--Spring or Well--Not Sparkling or Carbonated')
GL_ISO_CODES.set(59927, 'Water Bottling--Spring or Well--Sparkling or Carbonated')
GL_ISO_CODES.set(59931, 'Wax or Wax Products Mfg.')
GL_ISO_CODES.set(59932, 'Wax, Wax Products or Polish Mfg.--Floor')
GL_ISO_CODES.set(59941, 'Wheel Mfg.')
GL_ISO_CODES.set(59947, 'Wicker, Rattan, Willow or Twisted Fiber Products Mfg.')
GL_ISO_CODES.set(59955, 'Wigs or Hair Pieces Mfg.')
GL_ISO_CODES.set(59963, 'Wine Mfg.--Sparkling')
GL_ISO_CODES.set(59964, 'Wine Mfg.--Still')
GL_ISO_CODES.set(59970, 'Wire Cloth Mfg.')
GL_ISO_CODES.set(59973, 'Wire Drawing')
GL_ISO_CODES.set(59975, 'Wire Goods Mfg.')
GL_ISO_CODES.set(59977, 'Wire Rope or Cable Mfg.--Metal')
GL_ISO_CODES.set(59984, 'Wood Preserving')
GL_ISO_CODES.set(59985, 'Wood Products Mfg.')
GL_ISO_CODES.set(59986, 'Wood Turned Products Mfg.')
GL_ISO_CODES.set(59988, 'Wool Combing, Scouring or Separating from Cotton')
GL_ISO_CODES.set(59989, 'Wool Pulling')
GL_ISO_CODES.set(60010, 'Apartment Buildings')
GL_ISO_CODES.set(60011, 'Apartment Buildings--Garden')
GL_ISO_CODES.set(60012, 'Apartment Buildings or Hotels Time-Sharing--Less Than 4 Stories')
GL_ISO_CODES.set(60013, 'Apartment Buildings or Hotels Time-Sharing--4 Stories or More')
GL_ISO_CODES.set(60015, 'Apartment Hotels--Less Than 4 Stories')
GL_ISO_CODES.set(60016, 'Apartment Hotels--4 Stories or More')
GL_ISO_CODES.set(60035, 'Automobile Renting or Leasing Companies')
GL_ISO_CODES.set(61000, 'Boarding or Rooming Houses')
GL_ISO_CODES.set(61212, "Buildings or Premises--Bank or Office--Mercantile or Mfg. (Lessor's Risk Only)--Other Than Not-For-Profit")
GL_ISO_CODES.set(61216, "Buildings or Premises--Bank or Office--Mercantile or Mfg. (Lessor's Risk Only)--Not-For-Profit Only")
GL_ISO_CODES.set(
  61217,
  "Buildings or Premises--Bank or Office--Mercantile or Mfg. (Lessor's Risk Only)--Maintained by the Insured--Other Than Not-For-Profit"
)
GL_ISO_CODES.set(
  61218,
  "Buildings or Premises--Bank or Office--Mercantile or Mfg. (Lessor's Risk Only)--Maintained by the Insured--Not-For-Profit Only"
)
GL_ISO_CODES.set(61223, 'Buildings or Premises--Bank and Other Financial Institutions')
GL_ISO_CODES.set(61224, 'Buildings or Premises--Office--Premises Occupied by Employees of the Insured--Other Than Not-For-Profit')
GL_ISO_CODES.set(61225, 'Buildings or Premises--Office--Premises Occupied by Employees of the Insured--Not-For-Profit Only')
GL_ISO_CODES.set(61226, 'Buildings or Premises--Office--Other Than Not-For-Profit')
GL_ISO_CODES.set(61227, 'Buildings or Premises--Office--Not-For-Profit Only')
GL_ISO_CODES.set(62000, 'Condominiums--Commercial--Bank or Mercantile, Mfg. or Office (Association Risk Only)')
GL_ISO_CODES.set(62001, 'Condominiums--Commercial Shopping Centers (Association Risk Only)')
GL_ISO_CODES.set(62002, 'Condominiums--Commercial Warehouses--Mfg. or Private (Association Risk Only)')
GL_ISO_CODES.set(62003, 'Condominiums--Residential--(Association Risk Only)')
GL_ISO_CODES.set(63010, "Dwellings--One-Family (Lessor's Risk Only)")
GL_ISO_CODES.set(63011, "Dwellings--Two-Family (Lessor's Risk Only)")
GL_ISO_CODES.set(63012, "Dwellings--Three-Family (Lessor's Risk Only)")
GL_ISO_CODES.set(63013, "Dwellings--Four-Family (Lessor's Risk Only)")
GL_ISO_CODES.set(63215, 'Exhibition or Convention Buildings--Other Than Not-For-Profit')
GL_ISO_CODES.set(63216, 'Exhibition or Convention Buildings--Not-For-Profit Only')
GL_ISO_CODES.set(63217, 'Exhibitions--In Buildings--Other Than Not-For-Profit')
GL_ISO_CODES.set(63218, 'Exhibitions--In Buildings--Not-For-Profit Only')
GL_ISO_CODES.set(63219, 'Exhibitions--In Buildings--No Admission Charged--Other Than Not-For-Profit')
GL_ISO_CODES.set(63220, 'Exhibitions--In Buildings--No Admission Charged--Not-For-Profit Only')
GL_ISO_CODES.set(64074, "Hotels and Motels--(Lessor's Risk Only)--Less Than Four Stories")
GL_ISO_CODES.set(64075, "Hotels and Motels--(Lessor's Risk Only)--Four Stories or More")
GL_ISO_CODES.set(64500, 'Housing Projects--Federal, State, Local')
GL_ISO_CODES.set(65007, 'Labor Union Offices')
GL_ISO_CODES.set(66122, 'Lawyers Offices--Other Than Not-For-Profit')
GL_ISO_CODES.set(66123, 'Lawyers Offices--Not-For-Profit Only')
GL_ISO_CODES.set(66309, 'Libraries')
GL_ISO_CODES.set(66561, 'Medical Offices')
GL_ISO_CODES.set(67017, 'Shelters, Mission, Settlement or Halfway Houses--Not Church or Office Building')
GL_ISO_CODES.set(67508, 'Schools--Colleges, Universities, Junior Colleges or College Preparatory Other Than Not-For-Profit')
GL_ISO_CODES.set(67509, 'Schools--Colleges, Universities, Junior Colleges or College Preparatory Not-For-Profit Only')
GL_ISO_CODES.set(67510, 'Schools--Dormitory Facilities--Other Than Not-For-Profit')
GL_ISO_CODES.set(67511, 'Schools--Dormitory Facilities--Not-For-Profit Only')
GL_ISO_CODES.set(67512, 'Schools--Other Than Not-For-Profit')
GL_ISO_CODES.set(67513, 'Schools--Not-For-Profit Only')
GL_ISO_CODES.set(67634, "Shopping Centers--Indoor Malls--Buildings or Premises Not Occupied by the Insured (Lessor's Risk Only)")
GL_ISO_CODES.set(67635, "Shopping Centers--Buildings or Premises Not Occupied by the Insured (Lessor's Risk Only)")
GL_ISO_CODES.set(68001, 'Taxicab Companies')
GL_ISO_CODES.set(68439, 'Ticket Agencies')
GL_ISO_CODES.set(68500, 'Townhouses or Similar Associations (Association Risk Only)')
GL_ISO_CODES.set(68604, 'Vacant Buildings--Factories')
GL_ISO_CODES.set(68606, 'Vacant Buildings--Not Factories--Other Than Not-For-Profit')
GL_ISO_CODES.set(68607, 'Vacant Buildings--Not Factories--Not-For-Profit Only')
GL_ISO_CODES.set(68702, "Warehouses--Occupied by Multiple Interests (Lessor's Risk Only)")
GL_ISO_CODES.set(68703, "Warehouses--Occupied by Single Interest (Lessor's Risk Only)")
GL_ISO_CODES.set(68706, 'Warehouses--Private--Other Than Not-For-Profit')
GL_ISO_CODES.set(68707, 'Warehouses--Private--Not-For-Profit Only')
GL_ISO_CODES.set(90089, 'Advertising Sign Companies--Outdoor')
GL_ISO_CODES.set(91111, 'Air Conditioning Systems or Equipment--Dealers or Distributors and Installation, Servicing or Repair')
GL_ISO_CODES.set(91125, 'Airport Runway or Warming Apron--Paving or Repaving, Surfacing, Resurfacing or Scraping')
GL_ISO_CODES.set(91127, 'Alarms and Alarm Systems--Installation, Servicing or Repair')
GL_ISO_CODES.set(91130, 'Alarms--Security Systems--Monitoring')
GL_ISO_CODES.set(91135, 'Analytical Chemists')
GL_ISO_CODES.set(91150, 'Appliances and Accessories--Installation, Servicing or Repair--Commercial')
GL_ISO_CODES.set(91155, 'Appliances and Accessories--Installation, Servicing or Repair--Household')
GL_ISO_CODES.set(91160, 'Armored Car Service Companies')
GL_ISO_CODES.set(91175, "Auctioneers--Livestock--Sales Conducted Away from the Insured's Premises")
GL_ISO_CODES.set(91177, "Auctioneers--Sales Conducted Away from the Insured's Premises")
GL_ISO_CODES.set(91179, 'Auctions--on Premises Owned or Rented by the Insured')
GL_ISO_CODES.set(91190, 'Automobile Dismantling')
GL_ISO_CODES.set(91200, 'Blacksmithing')
GL_ISO_CODES.set(91210, 'Blasting Operations')
GL_ISO_CODES.set(91235, 'Boat Repair and Servicing')
GL_ISO_CODES.set(91250, 'Boiler Inspection, Installation, Cleaning or Repair')
GL_ISO_CODES.set(91265, 'Bridge or Elevated Highway Construction--Iron or Steel')
GL_ISO_CODES.set(91266, 'Bridge or Elevated Highway Construction--Concrete')
GL_ISO_CODES.set(91280, 'Building Structure--Raising or Moving')
GL_ISO_CODES.set(91302, 'Cable Installation in Conduits or Subways')
GL_ISO_CODES.set(91315, 'Cable or Subscription Television Companies')
GL_ISO_CODES.set(91324, 'Caisson or Cofferdam Work--Foundations for Buildings')
GL_ISO_CODES.set(91325, 'Caisson or Cofferdam Work--Not Foundations for Buildings')
GL_ISO_CODES.set(91340, 'Carpentry--Construction of Residential Property Not Exceeding Three Stories in Height')
GL_ISO_CODES.set(91341, 'Carpentry--Interior')
GL_ISO_CODES.set(91342, 'Carpentry')
GL_ISO_CODES.set(91343, 'Carpentry--Shop Only')
GL_ISO_CODES.set(91405, "Carpet, Rug, Furniture or Upholstery Cleaning--on Customers' Premises")
GL_ISO_CODES.set(91436, 'Ceiling or Wall Installation--Metal')
GL_ISO_CODES.set(91481, 'Chimney Cleaning')
GL_ISO_CODES.set(91507, 'Clay or Shale Digging')
GL_ISO_CODES.set(91523, 'Cleaning--Outside Surfaces of Buildings &amp; Other Exterior Surfaces')
GL_ISO_CODES.set(91547, 'Commissary Work')
GL_ISO_CODES.set(91551, 'Communication Equipment Installation--Industrial or Commercial')
GL_ISO_CODES.set(91555, 'Computer Service or Repair')
GL_ISO_CODES.set(91560, 'Concrete Construction')
GL_ISO_CODES.set(91562, 'Concrete or Cement Distributing Towers--Rented to Others--Installation, Repair or Removal Operations Only')
GL_ISO_CODES.set(91577, 'Conduit Construction for Cables or Wires')
GL_ISO_CODES.set(91580, 'Contractors--Executive Supervisors or Executive Superintendents')
GL_ISO_CODES.set(
  91581,
  'Contractors--Subcontracted Work--In Connection with Construction, Reconstruction, Erection or Repair--Not Buildings'
)
GL_ISO_CODES.set(
  91582,
  'Contractors--Subcontracted Work--In Connection with Building Construction, Reconstruction, Repair or Erection--Apartment or Office Buildings over Four Stories'
)
GL_ISO_CODES.set(
  91583,
  'Contractors--Subcontracted Work--In Connection with Building Construction, Reconstruction, Repair or Erection--One- or Two-Family Dwellings'
)
GL_ISO_CODES.set(
  91584,
  'Contractors--Subcontracted Work--In Connection with Construction, Reconstruction, Repair or Erection of Buildings--for Industrial Use'
)
GL_ISO_CODES.set(91585, 'Contractors--Subcontracted Work--In Connection with Construction, Reconstruction, Repair or Erection of Buildings')
GL_ISO_CODES.set(91586, 'Contractors--Subcontracted Work--In Connection with Oil and Gas Field Construction, Reconstruction or Repair')
GL_ISO_CODES.set(
  91587,
  'Contractors--Subcontracted Work--In Connection with Pipeline (Other Than Oil or Gas) or Communication or Power Line Construction, Reconstruction or Repair'
)
GL_ISO_CODES.set(
  91588,
  'Contractors--Subcontracted Work--In Connection with Bridge, Tunnel, Elevated Street or Highway Construction, Reconstruction or Repair'
)
GL_ISO_CODES.set(91589, 'Contractors--Subcontracted Work--In Connection with Street or Highway Construction or Repair, Not Elevated')
GL_ISO_CODES.set(91590, 'Contractors Permanent Yards--Maintenance or Storage of Equipment or Material')
GL_ISO_CODES.set(91591, 'Contractors--Subcontracted Work--Other Than Construction-Related Work')
GL_ISO_CODES.set(91600, 'Construction or Project Manager')
GL_ISO_CODES.set(91606, 'Crop Spraying--by Contractors')
GL_ISO_CODES.set(91618, 'Dam or Reservoir Construction')
GL_ISO_CODES.set(91629, 'Debris Removal--Construction Site')
GL_ISO_CODES.set(91636, 'Detective or Investigative Agencies--Private')
GL_ISO_CODES.set(91641, 'Dike, Levee or Revetment Construction')
GL_ISO_CODES.set(91666, 'Diving--Marine')
GL_ISO_CODES.set(91722, 'Dock Operations--Coal, Grain or Ore')
GL_ISO_CODES.set(91746, 'Door, Window or Assembled Millwork--Installation--Metal')
GL_ISO_CODES.set(91805, 'Draftsmen')
GL_ISO_CODES.set(92053, 'Dredging--Gold--Endless Bucket or Ladder Type')
GL_ISO_CODES.set(92054, 'Dredging--Gold--Floating Dragline Type')
GL_ISO_CODES.set(92055, 'Dredging')
GL_ISO_CODES.set(92101, 'Drilling--Other Than Water')
GL_ISO_CODES.set(92102, 'Drilling--Water')
GL_ISO_CODES.set(92215, 'Driveway, Parking Area or Sidewalk--Paving or Repaving')
GL_ISO_CODES.set(92338, 'Dry Wall or Wallboard Installation')
GL_ISO_CODES.set(92445, 'Electric Light or Power Companies')
GL_ISO_CODES.set(92446, 'Electric Light or Power Line Construction')
GL_ISO_CODES.set(92447, 'Electric Light or Power Line Construction--Rural Utilities Service Projects Only')
GL_ISO_CODES.set(92451, 'Electrical Apparatus--Installation, Servicing or Repair')
GL_ISO_CODES.set(92478, 'Electrical Work--within Buildings')
GL_ISO_CODES.set(92593, 'Elevator or Escalator Inspecting, Installation, Servicing or Repair')
GL_ISO_CODES.set(92663, 'Engineers or Architects--Consulting--Not Engaged in Actual Construction')
GL_ISO_CODES.set(94007, 'Excavation')
GL_ISO_CODES.set(94099, 'Express Companies')
GL_ISO_CODES.set(94225, 'Farm Machinery Operations--by Contractors')
GL_ISO_CODES.set(94276, 'Fence Erection Contractors')
GL_ISO_CODES.set(94304, 'Fire Extinguishers--Servicing, Refilling or Testing')
GL_ISO_CODES.set(94381, 'Fire Suppression Systems--Installation, Servicing or Repair')
GL_ISO_CODES.set(94404, 'Fireproofing--Structures')
GL_ISO_CODES.set(94444, 'Contractors')
GL_ISO_CODES.set(94569, 'Floor Covering Installation--Not Ceramic Tile or Stone')
GL_ISO_CODES.set(94590, 'Floor Waxing')
GL_ISO_CODES.set(94617, 'Freight Forwarders or Handlers--Other Than Packing, Handling or Shipping Explosives or Ammunition under Contract')
GL_ISO_CODES.set(94638, 'Freight Forwarders or Handlers--Packing, Handling or Shipping Explosives or Ammunition under Contract')
GL_ISO_CODES.set(95124, 'Furniture or Fixtures--Installation in Offices or Stores--Portable--Metal or Wood')
GL_ISO_CODES.set(95233, 'Garbage, Ash or Refuse Collecting')
GL_ISO_CODES.set(95305, 'Gas Companies')
GL_ISO_CODES.set(95306, 'Gas Companies--Natural Gas--Local Distribution')
GL_ISO_CODES.set(95310, 'Gas Mains or Connections Construction')
GL_ISO_CODES.set(95357, 'Geophysical Exploration--Other')
GL_ISO_CODES.set(95358, 'Geophysical Exploration--Seismic Method')
GL_ISO_CODES.set(95410, 'Grading of Land')
GL_ISO_CODES.set(95455, 'Grain Elevator Operations')
GL_ISO_CODES.set(95487, 'Greenhouse Erection')
GL_ISO_CODES.set(95505, 'Guniting or Shot-Crete')
GL_ISO_CODES.set(95620, 'Gunsmiths')
GL_ISO_CODES.set(95625, 'Handyperson')
GL_ISO_CODES.set(95630, 'Hazardous Material Contractors')
GL_ISO_CODES.set(
  95647,
  'Heating or Combined Heating and Air Conditioning Systems or Equipment--Dealers or Distributors and Installation, Servicing or Repair--No Liquefied Petroleum Gas (LPG) Equipment Sales or Work'
)
GL_ISO_CODES.set(
  95648,
  'Heating or Combined Heating and Air Conditioning Systems or Equipment--Dealers or Distributors and Installation, Servicing or Repair'
)
GL_ISO_CODES.set(96053, 'House Furnishings Installation')
GL_ISO_CODES.set(96317, 'Inspection and Appraisal Companies--Inspecting for Insurance or Valuation Purposes')
GL_ISO_CODES.set(96408, 'Insulation Work--Plastic')
GL_ISO_CODES.set(96409, 'Insulation Work--Organic or Plastic in Solid State')
GL_ISO_CODES.set(96410, 'Insulation Work--Mineral')
GL_ISO_CODES.set(96611, 'Interior Decorators')
GL_ISO_CODES.set(96702, 'Irrigation or Drainage System Construction')
GL_ISO_CODES.set(96703, 'Irrigation Works Operations')
GL_ISO_CODES.set(96816, 'Janitorial Services')
GL_ISO_CODES.set(96872, 'Jetty or Breakwater Construction')
GL_ISO_CODES.set(96930, 'Web Site Designers')
GL_ISO_CODES.set(97002, 'Laboratories--Research, Development or Testing--Other Than Not-For-Profit')
GL_ISO_CODES.set(97003, 'Laboratories--Research, Development or Testing--Not-For-Profit Only')
GL_ISO_CODES.set(97047, 'Landscape Gardening')
GL_ISO_CODES.set(97050, 'Lawn Care Services')
GL_ISO_CODES.set(97111, 'Logging and Lumbering')
GL_ISO_CODES.set(97220, 'Machine Shops')
GL_ISO_CODES.set(97221, 'Machinery or Equipment--Farm--Installation, Servicing, Repair or Erection')
GL_ISO_CODES.set(97222, 'Machinery or Equipment--Industrial--Installation, Servicing or Repair')
GL_ISO_CODES.set(97223, 'Machinery or Equipment--Installation, Servicing or Repair')
GL_ISO_CODES.set(97308, 'Marine Appraisers or Surveyors')
GL_ISO_CODES.set(97447, 'Masonry')
GL_ISO_CODES.set(97650, 'Metal Erection--Decorative or Artistic')
GL_ISO_CODES.set(97651, 'Metal Erection--Frame Structures Iron Work on Outside of Buildings')
GL_ISO_CODES.set(97652, 'Metal Erection--In the Construction of Dwellings Not Exceeding 2 Stories in Height')
GL_ISO_CODES.set(97653, 'Metal Erection--Nonstructural')
GL_ISO_CODES.set(
  97654,
  'Metal Erection--Steel Lock Gates, Gasholders, Standpipes, Water Towers, Smokestacks, Tanks, Silos, Prison Cells, Fire or Burglarproof Vaults'
)
GL_ISO_CODES.set(97655, 'Metal Erection--Structural')
GL_ISO_CODES.set(98002, 'Mining')
GL_ISO_CODES.set(98003, 'Mining--Surface')
GL_ISO_CODES.set(98090, 'Motion Pictures--Development of Negatives, Printing and All Subsequent Operations')
GL_ISO_CODES.set(98091, 'Motion Pictures--Film Distribution or Exchanges--Not Located at Motion Picture Studios')
GL_ISO_CODES.set(98092, 'Motion Pictures--Production--Studios or Outside--All Operations Prior to the Development of Negatives')
GL_ISO_CODES.set(98111, 'Office Machines or Appliances--Installation, Inspection, Adjustment or Repair')
GL_ISO_CODES.set(98150, 'Oil or Natural Gas Lease Operations')
GL_ISO_CODES.set(
  98151,
  'Oil or Gas Lease Operations--Natural Gas--within the Limits of Any Town or City on the Right-Of-Way of Any Railroad or in Any Ocean, Gulf or Bay'
)
GL_ISO_CODES.set(98152, 'Oil or Gas Lease Work by Contractors--Not Lease Operation')
GL_ISO_CODES.set(98153, 'Oil or Gas Wells--Acidizing')
GL_ISO_CODES.set(98154, 'Oil or Gas Wells--Cementing')
GL_ISO_CODES.set(98155, 'Oil or Gas Wells--Cleaning or Swabbing by Contractors')
GL_ISO_CODES.set(
  98156,
  'Oil or Gas Wells--Cleaning or Swabbing by Contractors--within the Limits of Any Town or City, on the Right-Of-Way of Any Railroad or in Any Ocean, Gulf or Bay'
)
GL_ISO_CODES.set(98157, 'Oil or Gas Wells--Drilling or Redrilling, Installation or Recovery of Casing')
GL_ISO_CODES.set(
  98158,
  'Oil or Gas Wells--Drilling or Redrilling, Installation or Recovery of Casing--within the Limits of Any Town or City, on the Right-Of-Way of Any Railroad or in Any Ocean, Gulf or Bay'
)
GL_ISO_CODES.set(98159, 'Oil or Gas Wells--Instrument Logging or Survey Work in Wells')
GL_ISO_CODES.set(98160, 'Oil or Gas Wells--Perforating of Casing')
GL_ISO_CODES.set(98161, 'Oil or Gas Wells--Servicing--By Contractors')
GL_ISO_CODES.set(98162, 'Oil or Gas Wells--Shooting')
GL_ISO_CODES.set(98163, 'Oil Rig or Derrick Erecting or Dismantling--Wood or Metal')
GL_ISO_CODES.set(98164, 'Oil Still Erection or Repair')
GL_ISO_CODES.set(98257, 'Orchards and Vineyards--Operation by Contractors')
GL_ISO_CODES.set(98303, 'Painting--Exterior--Buildings or Structures--Exceeding Three Stories in Height')
GL_ISO_CODES.set(98304, 'Painting--Exterior--Buildings or Structures--Three Stories or Less in Height')
GL_ISO_CODES.set(98305, 'Painting--Interior--Buildings or Structures')
GL_ISO_CODES.set(98306, 'Painting--Oil or Gasoline Tanks')
GL_ISO_CODES.set(98307, 'Painting--Ship Hulls')
GL_ISO_CODES.set(98308, 'Painting--Shop Only')
GL_ISO_CODES.set(98309, 'Painting--Steel Structures or Bridges')
GL_ISO_CODES.set(98344, 'Paperhanging')
GL_ISO_CODES.set(98405, 'Piano Tuning')
GL_ISO_CODES.set(98413, 'Pile Driving--Building Foundation Only')
GL_ISO_CODES.set(98414, 'Pile Driving--Other')
GL_ISO_CODES.set(98415, 'Pile Driving--Sonic Method')
GL_ISO_CODES.set(98423, 'Pipeline Construction--Gas')
GL_ISO_CODES.set(98424, 'Pipeline Construction--Other')
GL_ISO_CODES.set(98425, 'Pipeline Construction--Oil')
GL_ISO_CODES.set(98426, 'Pipeline Construction--Slurry--Nonflammable Mixtures')
GL_ISO_CODES.set(98427, 'Pipelines--Operation--Gas')
GL_ISO_CODES.set(98428, 'Pipelines--Operation--Other')
GL_ISO_CODES.set(98429, 'Pipelines--Operation--Oil')
GL_ISO_CODES.set(98430, 'Pipelines--Operation--Slurry--Nonflammable Mixtures')
GL_ISO_CODES.set(98449, 'Plastering or Stucco Work')
GL_ISO_CODES.set(98482, 'Plumbing--Commercial and Industrial')
GL_ISO_CODES.set(98483, 'Plumbing--Residential or Domestic')
GL_ISO_CODES.set(98502, 'Prefabricated Building Erection')
GL_ISO_CODES.set(98555, 'Quarries')
GL_ISO_CODES.set(98597, 'Radio or TV Broadcasting Stations--Other Than Not-For-Profit')
GL_ISO_CODES.set(98598, 'Radio or TV Broadcasting Stations--Not-For-Profit Only')
GL_ISO_CODES.set(98601, 'Railroad Construction')
GL_ISO_CODES.set(98622, 'Railroads--Operation and Maintenance--with BI Passenger Hazard')
GL_ISO_CODES.set(98623, 'Railroads--Operation and Maintenance--without BI Passenger Hazard')
GL_ISO_CODES.set(98624, 'Railroads--Shop Operation and Maintenance')
GL_ISO_CODES.set(98636, 'Refrigeration Systems or Equipment--Dealers and Distributors and Installation, Servicing or Repair--Commercial')
GL_ISO_CODES.set(98640, 'Renovating--Outside Surfaces of Buildings')
GL_ISO_CODES.set(98658, 'Rigging--Not Ship or Boat')
GL_ISO_CODES.set(98659, 'Rigging--Ship or Boat')
GL_ISO_CODES.set(98677, 'Roofing--Commercial or Residential Over Three Stories')
GL_ISO_CODES.set(98678, 'Roofing--Residential--Three Stories &amp; Under')
GL_ISO_CODES.set(98698, 'Salvage Operations')
GL_ISO_CODES.set(98699, 'Salvage Operations--Removing, Sorting, Reconditioning and Distributing of Merchandise in Damaged')
GL_ISO_CODES.set(98705, 'Sandblasting')
GL_ISO_CODES.set(98710, 'Sand or Gravel Digging')
GL_ISO_CODES.set(98751, 'Security and Patrol Agencies')
GL_ISO_CODES.set(98806, 'Septic Tank Systems--Installation, Servicing or Repair')
GL_ISO_CODES.set(98810, 'Sewage Disposal--Plant Operations')
GL_ISO_CODES.set(98813, 'Sewer Cleaning')
GL_ISO_CODES.set(98820, 'Sewer Mains or Connections Construction')
GL_ISO_CODES.set(98871, 'Shaft Sinking')
GL_ISO_CODES.set(98884, 'Sheet Metal Work--Outside')
GL_ISO_CODES.set(98914, 'Ship Ceiling or Scaling')
GL_ISO_CODES.set(98949, 'Ship Repair or Conversion')
GL_ISO_CODES.set(98967, 'Siding Installation')
GL_ISO_CODES.set(98993, 'Sign Erection, Installation or Repair')
GL_ISO_CODES.set(99003, 'Sign Painting or Lettering--Inside of Buildings')
GL_ISO_CODES.set(99004, 'Sign Painting or Lettering--on Buildings or Structures')
GL_ISO_CODES.set(99080, 'Solar Energy Contractors')
GL_ISO_CODES.set(99111, 'Stables--Boarding, Livery or Racing')
GL_ISO_CODES.set(99160, 'Steam Heating or Steam Power Companies')
GL_ISO_CODES.set(99163, 'Steam Mains or Connections Construction')
GL_ISO_CODES.set(99165, 'Steam Pipe or Boiler Insulation')
GL_ISO_CODES.set(99220, 'Stevedoring--By Hand or by Means of Hand Trucks Exclusively--No Hoisting of Cargo')
GL_ISO_CODES.set(99221, 'Stevedoring--Handling Explosives or Ammunition--under Contract')
GL_ISO_CODES.set(99222, 'Stevedoring')
GL_ISO_CODES.set(99223, 'Stevedoring--Tallyers or Checking Clerks Engaged in Connection with Stevedoring Work')
GL_ISO_CODES.set(99303, 'Street Cleaning')
GL_ISO_CODES.set(99310, 'Snow &amp; Ice Removal--Contractor')
GL_ISO_CODES.set(99315, 'Street or Road Construction or Reconstruction')
GL_ISO_CODES.set(99321, 'Street or Road Paving or Repaving, Surfacing or Resurfacing or Scraping')
GL_ISO_CODES.set(99471, 'Surveyors--Land--Not Engaged in Actual Construction')
GL_ISO_CODES.set(99505, 'Swimming Pool Servicing')
GL_ISO_CODES.set(99506, 'Swimming Pools--Installation, Servicing or Repair--Above Ground')
GL_ISO_CODES.set(99507, 'Swimming Pools--Installation, Servicing or Repair--Below Ground')
GL_ISO_CODES.set(99570, 'Tank Construction, Installation, Erection or Repair--Metal--Not Pressurized')
GL_ISO_CODES.set(99571, 'Tank Construction, Installation, Erection or Repair--Metal--Pressurized')
GL_ISO_CODES.set(99572, 'Tank Construction, Installation, Erection or Repair--Metal--Not Pressurized--within Buildings Exclusively')
GL_ISO_CODES.set(99573, 'Tank Construction, Installation, Erection or Repair--Metal--Pressurized--within Buildings Exclusively')
GL_ISO_CODES.set(99600, 'Telecommunications Service Providers')
GL_ISO_CODES.set(99613, 'Telephone, Telegraph or Cable Television Line Construction')
GL_ISO_CODES.set(99614, 'Telegraph Companies')
GL_ISO_CODES.set(99620, 'Teleproduction Studios')
GL_ISO_CODES.set(99650, 'Television or Radio Receiving Set Installation or Repair')
GL_ISO_CODES.set(99709, 'Tent or Canvas Goods--Erection, Removal or Repair--Away from Shop')
GL_ISO_CODES.set(99718, 'Theatrical Companies--Traveling')
GL_ISO_CODES.set(99746, 'Tile, Stone, Marble, Mosaic or Terrazzo Work--Interior Construction')
GL_ISO_CODES.set(99760, 'Tobacco Rehandling or Warehousing')
GL_ISO_CODES.set(99777, 'Tree Pruning, Dusting, Spraying, Repairing, Trimming or Fumigating')
GL_ISO_CODES.set(99793, 'Truckers')
GL_ISO_CODES.set(99798, 'Tunneling')
GL_ISO_CODES.set(99803, 'Underpinning Buildings or Structures')
GL_ISO_CODES.set(99826, 'Upholstering')
GL_ISO_CODES.set(99827, 'Upholstering--Shop Only')
GL_ISO_CODES.set(99851, 'Veterinarian or Veterinary Hospitals')
GL_ISO_CODES.set(99917, 'Warehouse--Cold Storage--Public')
GL_ISO_CODES.set(99938, 'Warehouses')
GL_ISO_CODES.set(99943, 'Water Companies')
GL_ISO_CODES.set(99946, 'Water Mains or Connections Construction')
GL_ISO_CODES.set(99948, 'Water Softening Equipment--Installation, Servicing or Repair')
GL_ISO_CODES.set(99952, 'Waterproofing--By Pressure Apparatus')
GL_ISO_CODES.set(99953, 'Waterproofing--By Trowel--Exterior')
GL_ISO_CODES.set(99954, 'Waterproofing--By Trowel--Interior or Insulation Work')
GL_ISO_CODES.set(99955, 'Waterproofing')
GL_ISO_CODES.set(99963, 'Weighers, Samplers or Inspectors of Merchandise--on Vessels or Docks or at Railway Stations or Warehouses')
GL_ISO_CODES.set(99969, 'Welding or Cutting')
GL_ISO_CODES.set(99975, 'Window Cleaning')
GL_ISO_CODES.set(99986, 'Wrecking--Buildings or Structures')
GL_ISO_CODES.set(99987, 'Wrecking--Dismantling of Prefabricated Dwellings Not Exceeding Three Stories for Reerection')
GL_ISO_CODES.set(99988, 'Wrecking--Marine')
GL_ISO_CODES.set(441105, 'Governmental: Municipalities--Population 100,001-250,000')

export { GL_ISO_CODES }
